/* JOLI POT, cadeau d'entreprise : configurateur (fichier assets/jp-entreprise.js) */
(function () {
  function init(el) {
    var cfg;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
    var R = document.getElementById(cfg.racine);
    if (!R || R.dataset.pret) return;
    R.dataset.pret = '1';
    var TX = cfg.tx || {};
    var TVA = 1.2;
    /* Bloque le défilement derrière une fenêtre sans faire sauter la page (on compense la largeur de la barre de défilement) */
    function bloquerPage(on) {
      var h = document.documentElement;
      if (on) { var sw = window.innerWidth - h.clientWidth; h.style.overflow = 'hidden'; if (sw > 0) h.style.paddingRight = sw + 'px'; }
      else { h.style.overflow = ''; h.style.paddingRight = ''; }
    }
    function petit(s) { return String(s == null ? '' : s).replace(/Mini pot/g, 'Petit pot').replace(/mini pot/g, 'petit pot').replace(/Mini bougie/g, 'Petite bougie').replace(/mini bougie/g, 'petite bougie'); }
    function T(k, v) { var s = petit(TX[k] || ''); if (k === 't_event_court' && /crivez-moi/.test(s)) s = 'Le délai est serré pour cette date.'; if (k === 't_devis' && s.indexOf('même modèle') < 0) s = s.replace('{max} pièces,', '{max} pièces pour un même modèle,'); if (v) Object.keys(v).forEach(function (x) { s = s.split('{' + x + '}').join(v[x]); }); return s; }
    function $(id) { return document.getElementById(id); }
    function q(sel) { return R.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(R.querySelectorAll(sel)); }
    function eur(n) { return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €'; }
    function ht(cents) { return cents / 100 / TVA; }
    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    /* ---- Lecture des déclinaisons : Modèle / Finition / Personnalisation ---- */
    var V = cfg.variantes || [];
    function typeModele(nom) { var n = String(nom).toLowerCase(); return n.indexOf('kit') > -1 ? 'kit' : (n.indexOf('bougie') > -1 ? 'bougie' : (n.indexOf('flora') > -1 ? 'flora' : 'mini')); }
    function persoDe(v) { var n = String(v.o[2] || '').toLowerCase(); return { logo: n.indexOf('logo') > -1, verso: n.indexOf('verso') > -1 }; }
    var modeles = (cfg.modeles || []).filter(function (m) { return V.some(function (v) { return v.o[0] === m && v.a; }); });
    function finitionsDe(m) { var f = []; V.forEach(function (v) { if (v.o[0] === m && f.indexOf(v.o[1]) < 0) f.push(v.o[1]); }); return f; }
    function trouver(m, f, logo, verso) {
      return V.filter(function (v) { var p = persoDe(v); return v.o[0] === m && v.o[1] === f && p.logo === logo && p.verso === verso; })[0] || null;
    }
    function prixMin(m) { var x = V.filter(function (v) { return v.o[0] === m; }).map(function (v) { return v.p; }); return x.length ? Math.min.apply(null, x) : 0; }

    /* ---- Paliers de remise (affichage) ---- */
    var PAL = String(cfg.paliers || '').split(',').map(function (x) { var a = x.split(':'); return [parseInt(a[0], 10), parseFloat(a[1])]; })
      .filter(function (a) { return a[0] > 0 && a[1] > 0; }).sort(function (a, b) { return a[0] - b[0]; });
    function remise(n) { var r = 0; PAL.forEach(function (a) { if (n >= a[0]) r = a[1]; }); return r; }

    /* ---- État ---- */
    var CARTE = '__carte';
    var E = { m: modeles[0], f: null, logo: true, verso: false, vmode: 'meme', carte: '', face: 'recto', fichierUrl: null, fichierPdf: false, dejaPanier: 0, dejaCartes: 0, forfaitPanier: false };
    function estCarte() { return E.m === CARTE; }
    E.f = finitionsDe(E.m)[0];

    /* ---- Étape 1 : modèles ---- */
    /* Les cartes modèles sont écrites dans la page (lisibles par Google) ; le script ajoute seulement les petits dessins */
    var zm = $('jpe-modeles');
    function remplirDessins() {
      qa('[data-ill]').forEach(function (x) {
        var t = x.dataset.ill;
        if (t === 'carte') { x.innerHTML = dessinCarte({ mini: true }); return; }
        var m = modeles.filter(function (mm) { return typeModele(mm) === t; })[0];
        x.innerHTML = dessin({ t: t, f: m ? finitionsDe(m)[0] : '', mini: true });
      });
      requestAnimationFrame(ajusterCartes);
    }
    /* ---- Étape 2 : finitions ---- */
    function renduFinitions() {
      var fs = estCarte() ? [] : finitionsDe(E.m), z = $('jpe-finitions');
      if (fs.indexOf(E.f) < 0) E.f = fs[0];
      $('jpe-e2').hidden = fs.length < 2;
      z.innerHTML = '';
      fs.forEach(function (f) {
        var key = 'f_' + String(f).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z]/g, '');
        var lab = document.createElement('label'); lab.className = 'jpe-opt';
        lab.innerHTML = '<input type="radio" name="jpe-fin" value="' + esc(f) + '"' + (f === E.f ? ' checked' : '') + '><span><strong>' + esc(f) + '</strong><small>' + esc(T(key)) + '</small></span>';
        z.appendChild(lab);
      });
      numeroter();
    }
    function numeroter() {
      var n = 0;
      qa('.jpe-etape').forEach(function (fs) { if (fs.hidden) return; n++; var s = fs.querySelector('.jpe-num'); if (s) s.textContent = n; });
    }

    /* ---- Carte à planter : même rendu que le configurateur et le bon de commande (paysage 148 x 105) ---- */
    var COEUR_CA = '<svg viewBox="0 0 100 90" aria-hidden="true"><path fill="#8c3f34" d="M50 88C47 85 6 58 4 30 2 13 14 2 28 2c11 0 18 7 22 15 4-8 11-15 22-15 14 0 26 11 24 28-2 28-43 55-46 58z"/></svg>';
    var ECR = { machine: '"JP Orwell", "Courier New", Courier, monospace', main: 'Sacramento, "Brush Script MT", cursive' };
    var PLAFOND = { machine: 4.2, main: 6.5 };
    function potLogoFichier() { var f = $('jpe-fichier'); return f && f.files && f.files[0] && E.logo ? f.files[0] : null; }
    function logoCarteFichier() { var f = $('jpe-cfichier'); return (f && f.files && f.files[0]) || potLogoFichier(); }
    function logoCarteUrl() { var f = $('jpe-cfichier'); if (f && f.files && f.files[0]) return E.cfichierUrl; return potLogoFichier() && !E.fichierPdf ? E.fichierUrl : null; }
    function dessinCarte(o) {
      var ecr = /manus|main/i.test(o.style || '') ? 'main' : 'machine';
      if (ecr === 'main') chargerPolice();
      return '<div class="jpe-ca' + (o.mini ? ' jpe-ca--mini' : '') + '" data-ecr="' + ecr + '"><canvas aria-hidden="true"></canvas>'
        + '<div class="jpe-ca__zone"><div class="jpe-ca__texte">' + esc(o.mini ? '' : (o.txt || '')) + '</div><span class="jpe-ca__coeur">' + COEUR_CA + '</span></div>'
        + (o.logo ? '<img class="jpe-ca__logo jpe-ca__logo--client" alt="" src="' + o.logo + '">' : (cfg.calogo ? '<img class="jpe-ca__logo" alt="" src="' + cfg.calogo + '">' : '')) + '</div>';
    }
    function mouchetis(el) {
      var cv = el.querySelector('canvas'); if (!cv) return;
      var w = el.offsetWidth, h = el.offsetHeight, dp = window.devicePixelRatio || 1; if (!w) return;
      cv.width = w * dp; cv.height = h * dp;
      var g = cv.getContext('2d'); if (!g) return; g.scale(dp, dp); g.clearRect(0, 0, w, h);
      var sd = 7; function rnd() { sd = (sd * 16807) % 2147483647; return sd / 2147483647; }
      var k = w / 300;
      for (var i = 0; i < 90; i++) {
        var x = rnd() * w, y = rnd() * h, t = (0.5 + rnd() * 1.6) * Math.max(0.4, k);
        g.fillStyle = 'rgba(120,128,110,' + (0.25 + rnd() * 0.45) + ')';
        g.beginPath(); g.arc(x, y, t, 0, Math.PI * 2); g.fill();
      }
    }
    /* plus grande taille de texte qui tient dans la zone */
    function ajusterCarte(el) {
      var W = el.offsetWidth; if (!W) return;
      mouchetis(el);
      var txt = el.querySelector('.jpe-ca__texte'), zone = el.querySelector('.jpe-ca__zone'), co = el.querySelector('.jpe-ca__coeur'), ecr = el.dataset.ecr;
      txt.style.fontFamily = ECR[ecr];
      if (!txt.textContent) return;
      var zh = zone.clientHeight, zw = zone.clientWidth, h = zh - (co ? co.offsetHeight : 0) - zh * 0.12;
      var lo = 1, hi = Math.min(W * PLAFOND[ecr] / 100, h), best = lo;
      for (var i = 0; i < 12; i++) {
        var mid = (lo + hi) / 2; txt.style.fontSize = mid + 'px';
        if (txt.scrollHeight <= h && txt.scrollWidth <= zw) { best = mid; lo = mid; } else hi = mid;
      }
      txt.style.fontSize = best + 'px';
    }
    function ajusterCartes() { qa('.jpe-ca').forEach(ajusterCarte); }
    window.addEventListener('resize', function () { clearTimeout(init.tr); init.tr = setTimeout(ajusterCartes, 150); });

    /* ---- Dessin du pot : mêmes formes que le configurateur et le bon de commande ----
       Mini pot et mini bougie = forme habituelle (6 cm), kit = pot 8 cm blanc sur coupelle, Flora = pot 5 cm terra */
    function decouper(txt, max) {
      var mots = txt.split(' '), l = [], c = '';
      mots.forEach(function (w) { if ((c + ' ' + w).trim().length > max && c) { l.push(c); c = w; } else c = (c + ' ' + w).trim(); });
      if (c) l.push(c); return l;
    }
    var CTX_M = null;
    function largeurTxt(t) {
      if (!CTX_M) { try { CTX_M = document.createElement('canvas').getContext('2d'); } catch (e) {} }
      if (!CTX_M) return t.length * 0.4;
      CTX_M.font = "1px Sacramento, 'Brush Script MT', cursive"; return CTX_M.measureText(t).width;
    }
    var COEUR_POT = 'c-1-1-5-3.5-5-6 0-1.6 1-2.6 2.6-2.6 1 0 1.8.6 2.4 1.6.6-1 1.4-1.6 2.4-1.6 1.6 0 2.6 1 2.6 2.6 0 2.5-4 5-5 6z';
    function dessin(o) {
      /* petit = Flora (5 cm, terra, avec sa fleur) ; les autres = forme habituelle du pot 6 et 8 cm */
      var petit = o.t === 'flora', terra = o.t !== 'kit' && o.f && /terra/i.test(o.f);
      if (petit) terra = true;
      var coul = terra ? '#fff' : '#1d1a17';
      var s = '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="">';
      if (o.t === 'kit') s += '<ellipse cx="100" cy="166" rx="62" ry="9" fill="#b9644f"/><rect x="40" y="157" width="120" height="9" rx="3" fill="#ad523f"/>';
      if (petit) {
        s += '<path d="M72 96h56l-7 62H79z" fill="#c4704f"/><rect x="66" y="86" width="68" height="13" rx="3" fill="#b35f40"/>';
        s += '<path d="M100 86c-1-14-1-24 0-30" stroke="#647d69" stroke-width="3" fill="none"/><path d="M100 56c-3-6-14-8-14 1 0 7 10 11 14 16 4-5 14-9 14-16 0-9-11-7-14-1z" fill="#d23a3a"/>';
      } else {
        s += '<path d="M58 78h84l-10 82H68z" fill="' + (terra ? '#c4704f' : '#fff') + '"' + (terra ? '' : ' stroke="#e6ddd2"') + '/><rect x="50" y="64" width="100" height="18" rx="3" fill="' + (terra ? '#b35f40' : '#ad513f') + '"/>';
        if (o.t === 'bougie') s += '<ellipse cx="100" cy="66" rx="44" ry="5" fill="#f6efe2"/><path d="M100 65v-12" stroke="#2a211c" stroke-width="2"/><path d="M100 52c-6-8 0-16 0-21 0 5 6 13 0 21z" fill="#f2c94c"/>';
        if (o.t === 'kit') s += '<path d="M100 64c0-12 0-18 0-22" stroke="#647d69" stroke-width="3" fill="none"/><path d="M100 46c-9-8-19-3-17 5 8 2 13-1 17-5zM100 50c9-8 19-3 17 5-8 2-13-1-17-5z" fill="#647d69"/>';
      }
      if (o.mini) return s + '</svg>';
      var milieu = petit ? 128 : 121;
      if (o.face === 'verso') {
        if (o.vtxt) { var tv = texteSvg(o.vtxt, petit, milieu, coul, !o.vnc); s += tv.svg; if (!o.vnc) s += '<path ' + (petit ? 'transform="translate(100 ' + tv.coeur.toFixed(1) + ') scale(.75) translate(-100 0)" d="M100 0' : 'd="M100 ' + tv.coeur.toFixed(1)) + COEUR_POT + '" fill="' + (terra ? '#fff' : '#c8102e') + '"/>'; }
      } else if (o.logo) {
        /* logo d'environ 3 cm sur le pot */
        var c = petit ? 36 : 46, y = milieu - (petit ? 3 : 5) - c / 2;
        /* sur terre cuite, le logo est posé en blanc ; sur pot blanc, en couleurs */
        if (o.url && !o.pdf) {
          var fid = 'jpe-blanc-' + (++dessin.n);
          if (terra) s += '<defs><filter id="' + fid + '"><feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 1 0"/></filter></defs>';
          s += '<image href="' + o.url + '" x="' + (100 - c / 2) + '" y="' + y + '" width="' + c + '" height="' + c + '" preserveAspectRatio="xMidYMid meet"' + (terra ? ' filter="url(#' + fid + ')"' : '') + '/>';
        }
        else s += '<rect x="' + (100 - c / 2) + '" y="' + y + '" width="' + c + '" height="' + c + '" rx="3" fill="none" stroke="' + coul + '" stroke-dasharray="3 2.5" opacity=".7"/><text x="100" y="' + (y + c / 2 + 3) + '" text-anchor="middle" font-size="' + (petit ? 8 : 10) + '" font-family="sans-serif" fill="' + coul + '" opacity=".8">' + (o.pdf ? 'PDF' : 'LOGO') + '</text>';
      } else {
        var tt = texteSvg(o.txt || '', petit, milieu, coul, !o.nc);
        s += tt.svg;
        if (!o.nc) s += '<path ' + (petit ? 'transform="translate(100 ' + tt.coeur.toFixed(1) + ') scale(.75) translate(-100 0)" d="M100 0' : 'd="M100 ' + tt.coeur.toFixed(1)) + COEUR_POT + '" fill="' + (terra ? '#fff' : '#c8102e') + '"/>';
      }
      return s + '</svg>';
    }
    /* Écriture manuscrite, réglage identique au configurateur : le plus gros possible sans toucher les bords, 4 lignes max,
       interligne fixe et espace net entre le texte et le cœur */
    dessin.n = 0;
    function texteSvg(t, petit, milieu, coul, avecCoeur) {
      var txt = String(t).replace(/\s+/g, ' ').trim();
      var zW = petit ? 34 : 50, zH = petit ? 40 : 58, cap = petit ? 11 : 15, PAS = petit ? 10 : 14;
      var nbMots = txt.split(' ').length, cands = [], meilleur = null, fMax = 0;
      for (var cmax = 5; cmax <= 22; cmax++) {
        var ll = decouper(txt, cmax); if (ll.length > 4 || ll.join(' ').split(' ').length !== nbMots) continue;
        var w = Math.max.apply(null, ll.map(largeurTxt)) || 1;
        if (ll.length * PAS > zH) continue; var f = Math.min(cap, zW / w);
        cands.push({ l: ll, f: f }); if (f > fMax) fMax = f;
      }
      /* le moins de lignes possible (2 pour une phrase courte) tant que l'écriture reste lisible ; on écrit plus petit plutôt que d'empiler les mots */
      var fMin = petit ? 6.4 : 8.5;
      if (petit) cands.forEach(function (c) { if (c.l.length > 3) return; if (!meilleur || c.f > meilleur.f + 0.15 || (Math.abs(c.f - meilleur.f) <= 0.15 && c.l.length < meilleur.l.length)) meilleur = c; });
      if (!meilleur) cands.forEach(function (c) { if (c.f < Math.min(fMin, fMax)) return; if (c.l.length === 1 && nbMots > 2 && txt.length > 14) return; if (!meilleur || c.l.length < meilleur.l.length || (c.l.length === meilleur.l.length && c.f > meilleur.f)) meilleur = c; });
      var l, fs;
      if (meilleur) { l = meilleur.l; fs = meilleur.f; }
      else { l = decouper(txt, petit ? 9 : 10).slice(0, 4); fs = Math.min(cap, zW / (Math.max.apply(null, l.map(largeurTxt)) || 1)); }
      var hOff = fs * 0.3 + (petit ? 10 : 15);
      var bas = (l.length - 1) * PAS + (avecCoeur ? hOff : fs * 0.25);
      var y0 = milieu - (bas - fs * 0.72) / 2;
      var svg = l.map(function (x, i) { return '<text x="100" y="' + (y0 + i * PAS).toFixed(1) + '" font-family="Sacramento, \'Brush Script MT\', cursive" font-size="' + fs.toFixed(1) + '" text-anchor="middle" fill="' + coul + '">' + esc(x) + '</text>'; }).join('');
      return { svg: svg, coeur: y0 + (l.length - 1) * PAS + hOff };
    }
    var policeChargee = false;
    function chargerPolice() {
      if (policeChargee) return; policeChargee = true;
      var lk = document.createElement('link'); lk.rel = 'stylesheet'; lk.href = 'https://fonts.googleapis.com/css2?family=Sacramento&display=swap'; document.head.appendChild(lk);
      if (document.fonts && document.fonts.load) document.fonts.load('20px "Sacramento"').then(function () { CTX_M = null; majApercu(); ajusterCartes(); }, function () {});
    }

    /* ---- Lecture du formulaire ---- */
    function prenoms() { return $('jpe-liste').value.split(/\n/).map(function (x) { return x.trim(); }).filter(Boolean); }
    function qte() { var n = parseInt($('jpe-qte').value, 10); return isNaN(n) ? 0 : n; }
    $('jpe-qte').addEventListener('change', function () {
      var mn = minimum();
      if (qte() < mn && !(SEL.length && qte() === 0)) { $('jpe-qte').value = mn; tout(); erreurChamp(T(serie() ? 'e_min_serie' : 'e_min', { n: mn }), $('jpe-qte'), true); }
    });
    function serie() { return estCarte() || !!E.carte || E.logo; }
    function minimum() { if (serie()) return SEL.length && qte() === 0 ? 0 : (cfg.min || 1); return SEL.length ? 0 : Math.max(1, (cfg.min || 1) - (estCarte() ? E.dejaCartes : E.dejaPanier)); }
    function resteMin() { return Math.max(0, (cfg.min || 1) - E.dejaPanier - E.dejaCartes); }
    function carteChoisie() { if (!cfg.carte || !E.carte) return null; return cfg.carte.filter(function (c) { return String(c.id) === String(E.carte); })[0] || null; }

    function estTerra() { var t = typeModele(E.m); return t === 'flora' || (t !== 'kit' && /terra/i.test(E.f || '')); }
    function majChamps() {
      var t = typeModele(E.m), C = estCarte();
      if ($('jpe-logo-coul')) $('jpe-logo-coul').textContent = C ? '' : T(estTerra() ? 't_logo_terra' : 't_logo_blanc');
      /* modèle sans logo (Flora) : on retire le choix Logo et on passe en message */
      var aLogo = !C && V.some(function (v) { return v.o[0] === E.m && persoDe(v).logo; });
      var rl = q('input[name="jpe-recto"][value="logo"]'), rm = q('input[name="jpe-recto"][value="message"]');
      if (rl) rl.closest('label').style.display = (aLogo || C) ? '' : 'none';
      if (!C && !aLogo && E.logo) { E.logo = false; if (rm) rm.checked = true; chargerPolice(); }
      $('jpe-z-pot').hidden = C;
      if ($('jpe-z-carte')) {
        $('jpe-z-carte').classList.toggle('jpe-carte--seule', C);
        $('jpe-carte-non').hidden = C;
        var ct = $('jpe-carte-t'); ct.textContent = C ? ct.dataset.t2 : ct.dataset.t1; $('jpe-carte-d').hidden = C;
        if (C && !E.carte) { var r1 = q('input[name="jpe-carte"]:not([value=""])'); if (r1) { r1.checked = true; E.carte = r1.value; } }
      }
      $('jpe-z-logo').hidden = !E.logo;
      $('jpe-z-msg').hidden = E.logo;
      $('jpe-z-verso').hidden = !E.verso;
      $('jpe-vmsg').hidden = E.vmode !== 'meme';
      if ($('jpe-idees-v') && $('jpe-idees-v').querySelector('option')) $('jpe-idees-v').hidden = E.vmode !== 'meme';
      $('jpe-liste').hidden = E.vmode !== 'liste';
      $('jpe-liste-n').hidden = E.vmode !== 'liste';
      $('jpe-z-sachet').hidden = t !== 'kit' || C;
      $('jpe-btn-verso').hidden = !E.verso;
      $('jpe-btn-carte').hidden = !E.carte || C;
      q('.jpe-apercu__faces').hidden = (!E.verso && !E.carte) || C;
      if (!E.verso && E.face === 'verso') E.face = 'recto';
      if ((!E.carte || C) && E.face === 'carte') E.face = 'recto';
      var serie = C || !!E.carte || E.logo, qs = $('jpe-qte-serie');
      if (qs) { qs.hidden = !serie || !T('t_qte_serie'); qs.textContent = T('t_qte_serie', { n: cfg.min }); }
      qa('[data-face]').forEach(function (b) { b.classList.toggle('is-actif', b.dataset.face === E.face); });
      var zc = $('jpe-z-cmsg');
      if (zc) {
        zc.hidden = !E.carte;
        var r = q('input[name="jpe-carte"]:checked'), mx = r && r.dataset.max ? parseInt(r.dataset.max, 10) : 150;
        if ($('jpe-cmsg').maxLength !== mx) { $('jpe-cmsg').maxLength = mx; if (typeof BANQUE_C !== 'undefined' && BANQUE_C) BANQUE_C.maj(); }
        $('jpe-cmsg-max').textContent = mx;
        if ($('jpe-cmsg').value.length > mx) $('jpe-cmsg').value = $('jpe-cmsg').value.slice(0, mx);
        $('jpe-cmsg-n').textContent = $('jpe-cmsg').value.length;
      }
      if (E.vmode === 'liste' && E.verso) {
        var n = prenoms().length;
        $('jpe-liste-n').textContent = n ? T('t_liste_n', { n: n }) : '';
        if (n) $('jpe-qte').value = n;
      }
      $('jpe-qte').readOnly = !C && E.verso && E.vmode === 'liste' && prenoms().length > 0;
      $('jpe-msg-n').textContent = $('jpe-msg').value.length;
    }

    function majApercu() {
      var ca = $('jpe-clogo-aide'), cfi = $('jpe-cfichier');
      if (ca) ca.textContent = (!(cfi && cfi.files && cfi.files[0]) && potLogoFichier()) ? ca.dataset.t2 : ca.dataset.t1;
      var cfn = $('jpe-cfichier-nom'), cfi2 = $('jpe-cfichier');
      if (cfn && !(cfi2 && cfi2.files && cfi2.files[0])) cfn.textContent = potLogoFichier() && T('t_cfichier_autre') ? T('t_cfichier_autre') : T('t_cfichier');
      if (estCarte() || (E.carte && E.face === 'carte')) { $('jpe-pot').innerHTML = dessinCarte({ txt: $('jpe-cmsg').value || T('t_carte_msg'), style: (q('input[name="jpe-cstyle"]:checked') || {}).value, logo: logoCarteUrl() }); ajusterCarte($('jpe-pot').querySelector('.jpe-ca')); return; }
      var vtxt = E.vmode === 'liste' ? (prenoms()[0] || '') : $('jpe-vmsg').value;
      $('jpe-pot').innerHTML = dessin({ t: typeModele(E.m), f: E.f, logo: E.logo, url: E.fichierUrl, pdf: E.fichierPdf, txt: $('jpe-msg').value || T('t_msg_ph'), nc: sansCoeur(), vnc: sansCoeurV(), face: E.face, vtxt: vtxt || T('t_verso_ph') });
    }

    /* ---- Livraison estimée : jours ouvrés (sans week-ends, jours fériés ni fermetures de l'atelier) ---- */
    var DL = cfg.delais || [2, 10, 2];
    var FERME = String(cfg.fermetures || '').split(/\n/).map(function (l) {
      var m = l.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})\s*-\s*(\d{1,2})\/(\d{1,2})\/(\d{4})/); if (!m) return null;
      return [new Date(+m[3], +m[2] - 1, +m[1], 0, 0), new Date(+m[6], +m[5] - 1, +m[4], 23, 59)];
    }).filter(Boolean);
    function paques(y) {
      var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      return new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1, 12);
    }
    var FERIES = {};
    function feries(y) {
      if (FERIES[y]) return FERIES[y];
      var f = {}; ['1-1', '1-5', '8-5', '14-7', '15-8', '1-11', '11-11', '25-12'].forEach(function (x) { f[x] = 1; });
      var p = paques(y); [1, 39, 50].forEach(function (n) { var d = new Date(p); d.setDate(d.getDate() + n); f[d.getDate() + '-' + (d.getMonth() + 1)] = 1; });
      return (FERIES[y] = f);
    }
    function ouvre(d) { if (d.getDay() === 0 || d.getDay() === 6 || feries(d.getFullYear())[d.getDate() + '-' + (d.getMonth() + 1)]) return false; return !FERME.some(function (x) { return d >= x[0] && d <= x[1]; }); }
    function plusOuvres(d, n) { d = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12); var garde = 0; while (n > 0 && garde++ < 400) { d.setDate(d.getDate() + 1); if (ouvre(d)) n--; } return d; }
    function dateLivraison() { var n = (+DL[0] || 0) + (+DL[1] || 0) + (+DL[2] || 0); return n ? plusOuvres(new Date(), n) : null; }
    var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    function majLivraison() {
      var z = $('jpe-livraison'), d = dateLivraison(); if (!z) return;
      z.hidden = true;
      if (d) z.textContent = T('t_livraison', { date: JOURS[d.getDay()] + ' ' + (d.getDate() === 1 ? '1er' : d.getDate()) + ' ' + MOIS[d.getMonth()] });
    }

    /* ---- Mémo sous l'aperçu : calendrier transparent (BAT, validation, fabrication, transport) et date d'événement ---- */
    function dateCourt(d, ref) { var s = JOURS[d.getDay()].slice(0, 3) + '. ' + (d.getDate() === 1 ? '1er' : d.getDate()); return d.getMonth() === ref.getMonth() ? s : s + ' ' + MOIS[d.getMonth()]; }
    function dateTxt(d) { return JOURS[d.getDay()] + ' ' + (d.getDate() === 1 ? '1er' : d.getDate()) + ' ' + MOIS[d.getMonth()]; }
    function majMemo() {
      var b = +DL[0] || 0, f = +DL[1] || 0, t = +DL[2] || 0, v = +cfg.validation || 0, auj = new Date();
      var d1 = plusOuvres(auj, b + f + t), d2 = plusOuvres(auj, b + v + f + t);
      var liv = T('t_liv_est', { d1: dateCourt(d1, d2), d2: dateTxt(d2) });
      var et = [T('t_memo_bat', { date: dateTxt(plusOuvres(auj, b)) }), T('t_memo_valid', { n: v }), T('t_memo_fab', { n: f }), T('t_memo_liv', { d1: dateCourt(d1, d2), d2: dateTxt(d2) })]
        .map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('');
      qa('[data-jpe-liv]').forEach(function (x) { x.textContent = liv; });
      qa('[data-jpe-etapes]').forEach(function (x) { x.innerHTML = et; });
      var ev = $('jpe-event'), avecDate = !!(q('input[name="jpe-quand"]:checked') || {}).value && q('input[name="jpe-quand"]:checked').value === 'date';
      if ($('jpe-quand-date')) $('jpe-quand-date').hidden = !avecDate;
      var m = avecDate && ev && (ev.value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/), txt = '', court = false;
      if (m) {
        var cible = new Date(+m[1], +m[2] - 1, +m[3], 12), D = new Date(cible), garde = 0;
        while (plusOuvres(D, b + v + f + t) > cible && garde++ < 400) D.setDate(D.getDate() - 1);
        while (!ouvre(D) && garde++ < 420) D.setDate(D.getDate() - 1);
        court = D < new Date(auj.getFullYear(), auj.getMonth(), auj.getDate(), 12);
        txt = court ? T('t_event_court') : T('t_event_ok', { date: dateTxt(D) });
      }
      qa('[data-jpe-res]').forEach(function (x) {
        x.hidden = !txt; x.classList.toggle('is-court', court);
        x.innerHTML = esc(txt) + (court && T('t_event_lien') ? ' <button type="button" class="jpe-ech__lien jpe-event-lien" data-jpe-ecrire>' + esc(T('t_event_lien')) + '</button>' : '');
      });
    }
    if ($('jpe-event')) {
      var evMin = new Date(); $('jpe-event').min = evMin.getFullYear() + '-' + String(evMin.getMonth() + 1).padStart(2, '0') + '-' + String(evMin.getDate()).padStart(2, '0');
      $('jpe-event').addEventListener('change', majMemo); $('jpe-event').addEventListener('input', majMemo);
    }
    qa('input[name="jpe-quand"]').forEach(function (r) { r.addEventListener('change', function () { majMemo(); if (r.value === 'date' && r.checked) setTimeout(function () { $('jpe-event').focus(); }, 50); }); });
    document.addEventListener('click', function (e) {
      var w = e.target.closest && e.target.closest('[data-jpe-ecrire]'); if (!w) return;
      e.preventDefault(); $('jpe-devis').click();
    });
    R.addEventListener('click', function (e) {
      var bt = e.target.closest && e.target.closest('[data-jpe-info]'); if (!bt) return;
      var d = bt.parentNode.nextElementSibling; if (!d) return;
      d.hidden = !d.hidden; bt.setAttribute('aria-expanded', String(!d.hidden));
    });
    majMemo();

    /* ---- Sélection : plusieurs modèles dans une même commande, un même devis ---- */
    var SEL = [];
    try { SEL = JSON.parse(localStorage.getItem('jpe-sel-' + (cfg.produit || '')) || '[]') || []; } catch (e) { SEL = []; }
    if (!Array.isArray(SEL)) SEL = [];
    SEL = SEL.filter(function (sn) { return sn && sn.q > 0 && (sn.C || modeles.indexOf(sn.m) > -1); });
    function sansCoeurV() { return !!($('jpe-sanscoeur-v') && $('jpe-sanscoeur-v').checked); }
    function sansCoeur() { return !!($('jpe-sanscoeur') && $('jpe-sanscoeur').checked); }
    function sauverSel() { try { localStorage.setItem('jpe-sel-' + (cfg.produit || ''), JSON.stringify(SEL.map(function (sn) { return Object.assign({}, sn, { pr: sn.pr.length > 300 ? [] : sn.pr }); }))); } catch (e) {} }
    function snap() {
      var C = estCarte();
      return { C: C, m: E.m, f: C ? '' : (E.f || ''), logo: !C && E.logo, verso: !C && E.verso, vmode: E.vmode, t: $('jpe-msg').value.trim(), nc: !C && !E.logo && sansCoeur(), vnc: !C && E.verso && sansCoeurV(), vt: $('jpe-vmsg').value.trim(),
        pr: !C && E.verso && E.vmode === 'liste' ? prenoms() : [], carte: E.carte || '', cl: !!((C || E.carte) && logoCarteFichier()), ct: $('jpe-cmsg').value.trim(), cs: (q('input[name="jpe-cstyle"]:checked') || {}).value || '',
        s: !C && typeModele(E.m) === 'kit' && $('jpe-sachet') ? $('jpe-sachet').value : '', q: qte() };
    }
    function lignesTout() { var l = SEL.slice(); if (qte() > 0 || !SEL.length) l.push(snap()); return l; }
    function carteDe(id) { return (cfg.carte || []).filter(function (c) { return String(c.id) === String(id); })[0] || null; }
    function estTerraDe(sn) { var t = typeModele(sn.m); return t === 'flora' || (t !== 'kit' && /terra/i.test(sn.f || '')); }
    function nomLigne(sn) {
      if (sn.C) { var c = carteDe(sn.carte); return T('m_carte_nom') + (c && c.t && c.t !== 'Default Title' ? ', ' + c.t : ''); }
      return petit(sn.m) + (sn.f && finitionsDe(sn.m).length > 1 ? ', ' + sn.f : '');
    }
    function detailLigne(sn) {
      if (sn.C) return 'Message : « ' + sn.ct + ' »' + (sn.cs ? ' · ' + sn.cs : '') + (sn.cl ? ' · votre logo en noir' : '');
      var d = [sn.logo ? 'Recto : votre logo en sticker, ' + (estTerraDe(sn) ? 'blanc' : 'en couleurs') : 'Recto : « ' + sn.t + ' »' + (sn.nc ? ', sans cœur' : '')];
      if (sn.verso) d.push((sn.vmode === 'liste' ? 'Verso : un prénom par pièce' + (sn.pr.length ? ' (' + sn.pr.length + ' prénoms)' : '') : 'Verso : « ' + sn.vt + ' »') + (sn.vnc ? ', sans cœur' : ''));
      if (sn.s) d.push('Sachet : ' + sn.s);
      if (sn.carte) { var co = carteDe(sn.carte); if (co) d.push(T('m_carte_nom') + ' ' + co.t + ' : « ' + sn.ct + ' »' + (sn.cl ? ', votre logo en noir' : '')); }
      return d.join(' · ');
    }
    function calcTout() {
      var L = lignesTout(), pots = 0, qtot = 0, items = [], brutPots = 0, cartes = 0, logo = false;
      L.forEach(function (sn) { qtot += sn.q; if (!sn.C) pots += sn.q; });
      var r = remise(pots + E.dejaPanier);
      L.forEach(function (sn) {
        var it = { sn: sn, nom: nomLigne(sn), det: detailLigne(sn) };
        if (sn.C) { it.v = carteDe(sn.carte) || (cfg.carte || [])[0] || null; it.u = it.v ? ht(it.v.p) : 0; cartes += it.u * sn.q; }
        else {
          it.v = trouver(sn.m, sn.f, sn.logo, sn.verso); it.u = it.v ? ht(it.v.p) : 0; brutPots += it.u * sn.q; if (sn.logo) logo = true;
          if (sn.carte) { it.co = carteDe(sn.carte); if (it.co) { it.cu = ht(it.co.p); cartes += it.cu * sn.q; } }
        }
        items.push(it);
      });
      var sousPots = brutPots * (1 - r / 100), forf = logo && cfg.forfait && !E.forfaitPanier ? ht(cfg.forfait.p) : 0;
      return { L: L, items: items, pots: pots, qtot: qtot, r: r, brutPots: brutPots, sousPots: sousPots, cartes: cartes, forf: forf, tot: sousPots + cartes + forf };
    }
    function calcul() {
      var C = estCarte(), v = C ? null : trouver(E.m, E.f, E.logo, E.verso), c = carteChoisie();
      var n = qte(), total = n + (C ? E.dejaCartes : E.dejaPanier), r = C ? 0 : remise(total);
      var u = C ? (c ? ht(c.p) : 0) : (v ? ht(v.p) : 0), brut = u * n, sous = brut * (1 - r / 100);
      var forf = !C && E.logo && cfg.forfait && !E.forfaitPanier ? ht(cfg.forfait.p) : 0;
      var tc = !C && c ? ht(c.p) * n : 0;
      return { C: C, v: v, c: c, n: n, total: total, r: r, u: u, brut: brut, sous: sous, forf: forf, tc: tc, tot: sous + forf + tc };
    }
    function majPrix() {
      var k = calcul(), C = k.C, K = calcTout(), r = K.r, total = K.pots ? K.pots + E.dejaPanier : K.qtot + E.dejaCartes;
      if (k.v) $('jpe-id').value = k.v.id;
      var h = '';
      if (SEL.length) {
        h += '<ul class="jpe-sel">';
        K.items.forEach(function (it, i) {
          var cours = i >= SEL.length;
          h += '<li' + (cours ? ' class="is-cours"' : '') + '><span class="jpe-sel__t"><b>' + it.sn.q + ' × ' + esc(it.nom) + '</b>' + (cours ? ' <i>' + esc(T('t_sel_cours')) + '</i>' : '') + '<small>' + esc(it.det) + '</small></span>'
            + '<span class="jpe-sel__p">' + eur(it.u * it.sn.q + (it.cu || 0) * it.sn.q) + ' HT</span>'
            + (cours ? '' : '<button type="button" class="jpe-sel__x" data-sel-x="' + i + '">' + esc(T('t_sel_retirer')) + '</button>') + '</li>';
        });
        h += '</ul>';
      }
      h += '<dl>';
      if (!SEL.length) h += '<div><dt>' + esc(T('t_unite')) + '</dt><dd>' + eur(k.u) + ' HT</dd></div>';
      if (E.dejaPanier + E.dejaCartes > 0 && T('t_deja')) h += '<div class="jpe-recap__deja"><dt>' + esc(T('t_deja', { n: E.dejaPanier + E.dejaCartes })) + '</dt><dd></dd></div>';
      if (r) h += '<div class="jpe-recap__remise"><dt>' + esc(T('t_remise')) + '</dt><dd>-' + String(r).replace('.', ',') + ' %</dd></div>';
      if (!SEL.length && k.tc) h += '<div><dt>' + esc(T('t_ligne_carte')) + ' (' + k.n + ')</dt><dd>' + eur(k.tc) + ' HT</dd></div>';
      if (K.forf) h += '<div><dt>' + esc(T('t_forfait')) + '</dt><dd>' + eur(K.forf) + ' HT</dd></div>';
      h += '<div class="jpe-recap__total"><dt>' + esc(T('t_total')) + '</dt><dd>' + eur(K.tot) + '</dd></div>';
      h += '</dl><p class="jpe-recap__ttc">' + esc(T('t_ttc', { ttc: eur(K.tot * TVA) })) + '</p>';
      $('jpe-recap').innerHTML = h;
      /* barre livraison offerte (franco en HT, comme le profil d'expédition Entreprise) */
      var liv = $('jpe-liv');
      if (liv && cfg.franco && K.tot > 0) {
        var reste = cfg.franco - K.tot, ok = reste <= 0;
        liv.hidden = false; liv.classList.toggle('jpe-liv--ok', ok);
        liv.querySelector('.jpe-liv__txt').textContent = (ok ? '\u2713 ' : '') + (ok ? T('t_liv_ok') : T('t_liv_reste', { reste: eur(reste) }));
        liv.querySelector('.jpe-liv__barre i').style.width = Math.min(100, Math.round(K.tot / cfg.franco * 100)) + '%';
      } else if (liv) liv.hidden = true;
      var vs = trouver(E.m, E.f, E.logo, true), vn = trouver(E.m, E.f, E.logo, false);
      $('jpe-verso-prix').textContent = vs && vn ? '+' + eur(ht(vs.p - vn.p)) + ' HT' : '';
      qa('[data-prix-ttc]').forEach(function (x) { x.textContent = eur(ht(parseInt(x.dataset.prixTtc, 10))) + ' HT'; });
      var mn = minimum();
      $('jpe-qte').min = mn;
      $('jpe-qte-aide').textContent = T('t_qte_aide', { min: cfg.min });
      $('jpe-paliers').hidden = C;
      if (PAL.length) $('jpe-paliers').innerHTML = PAL.map(function (a) { return '<span class="' + (total >= a[0] ? 'is-ok' : '') + '">-' + a[1] + ' % dès ' + a[0] + '</span>'; }).join('');
      /* devis sur mesure : au-delà du maximum pour UN même modèle (ni le panier ni les autres modèles ne comptent) */
      var devis = !!cfg.max && (qte() > cfg.max || SEL.some(function (sn) { return sn.q > cfg.max; }));
      majLivraison();
      $('jpe-ajout').hidden = devis;
      $('jpe-devis-pdf').hidden = devis || !$('jpe-coord').hidden;
      $('jpe-devis-aide').hidden = devis;
      $('jpe-devis').hidden = !devis;
      if (devis) $('jpe-qte-aide').textContent = T('t_devis', { max: cfg.max });
      majBarre(K, devis);
    }
    function evBrut() { var qd = q('input[name="jpe-quand"]:checked'), v = $('jpe-event') && $('jpe-event').value; return qd && qd.value === 'date' && /^\d{4}-\d{2}-\d{2}$/.test(v || '') ? v : ''; }
    function dateEv() { var v = evBrut(); if (!v) return ''; var a = v.split('-'); return a[2] + '/' + a[1] + '/' + a[0]; }
    function remettreEv(v) { if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v) || !$('jpe-event')) return; var r = q('input[name="jpe-quand"][value="date"]'); if (r) r.checked = true; $('jpe-event').value = v; majMemo(); }
    function recapTexte() {
      var l = [], K = calcTout();
      l.push('Entreprise : ' + ($('jpe-ent').value || ''));
      if ($('jpe-po') && $('jpe-po').value.trim()) l.push('N° de bon de commande : ' + $('jpe-po').value.trim());
      if (dateEv()) l.push('Date de l\'événement : ' + dateEv());
      K.items.forEach(function (it) { l.push(it.sn.q + ' × ' + it.nom + ' (' + it.det + ')'); });
      l.push('Quantité totale : ' + K.qtot);
      return l.join('\n');
    }
    function tout() { majChamps(); majApercu(); majPrix(); }
    $('jpe-recap').addEventListener('click', function (e) {
      var b = e.target.closest('[data-sel-x]'); if (!b) return;
      SEL.splice(parseInt(b.dataset.selX, 10), 1); sauverSel();
      if (!SEL.length && qte() < minimum()) $('jpe-qte').value = minimum();
      tout();
    });

    /* ---- Événements ---- */
    R.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'jpe-modele') {
        var avant = estCarte(); E.m = t.value;
        if (avant && !estCarte()) { E.carte = ''; var rn = q('input[name="jpe-carte"][value=""]'); if (rn) rn.checked = true; }
        if (estCarte() && /manus/i.test((q('input[name="jpe-cstyle"]:checked') || {}).value || '')) chargerPolice();
        renduFinitions();
      }
      if (t.name === 'jpe-cstyle' && /manus/i.test(t.value)) chargerPolice();
      if (t.name === 'jpe-fin') E.f = t.value;
      if (t.name === 'jpe-recto') { E.logo = t.value === 'logo'; if (!E.logo) chargerPolice(); }
      if (t.name === 'jpe-verso') { E.verso = t.value === 'oui'; if (E.verso) { E.face = 'verso'; chargerPolice(); } }
      if (t.name === 'jpe-vmode') E.vmode = t.value;
      if (t.name === 'jpe-carte') { E.carte = t.value; if (E.carte) E.face = 'carte'; }
      if (t.name === 'jpe-cstyle' || t.id === 'jpe-cfichier') { if (E.carte) E.face = 'carte'; }
      if (t.id === 'jpe-fichier') {
        var f = t.files && t.files[0];
        if (E.fichierUrl) URL.revokeObjectURL(E.fichierUrl);
        E.fichierUrl = null; E.fichierPdf = false;
        if (f) { E.fichierPdf = /pdf/i.test(f.type) || /\.pdf$/i.test(f.name); if (!E.fichierPdf) { E.fichierUrl = URL.createObjectURL(f); rognerLogo(E.fichierUrl); } $('jpe-fichier-nom').textContent = f.name; }
        else $('jpe-fichier-nom').textContent = T('t_fichier');
        E.face = 'recto';
      }
      if (t.id === 'jpe-cfichier') {
        var cf = t.files && t.files[0];
        if (E.cfichierUrl) URL.revokeObjectURL(E.cfichierUrl);
        E.cfichierUrl = null;
        if (cf) { if (!/pdf/i.test(cf.type) && !/\.pdf$/i.test(cf.name)) { E.cfichierUrl = URL.createObjectURL(cf); rognerLogo(E.cfichierUrl, 'cfichierUrl'); } $('jpe-cfichier-nom').textContent = cf.name; }
        else $('jpe-cfichier-nom').textContent = T('t_cfichier');
      }
      if (t.type === 'radio' || t.type === 'checkbox' || t.type === 'file' || t.tagName === 'SELECT') cacherErreur();
      if (t.type === 'radio' && !$('jpe-qte').readOnly && qte() > 0 && qte() < minimum()) $('jpe-qte').value = minimum();
      tout();
    });
    /* Banque de messages : un thème, puis un message qui remplit le champ (recto, et verso « le même sur tous les pots ») */
    function banque(zid, champ, src) {
      var zone = $(zid);
      if (!zone || !champ || !src) return null;
      var maxi = 9999, themes = [], cur = null;
      String(src).split(/\r?\n/).forEach(function (l) {
        l = l.trim(); if (!l) return;
        if (l.charAt(0) === '#') { cur = { nom: l.replace(/^#+/, '').trim(), m: [] }; themes.push(cur); }
        else if (cur && l.length <= maxi) cur.m.push(l);
      });
      themes = themes.filter(function (t) { return t.nom && t.m.length; });
      if (!themes.length) return;
      var sel = $(zid + '-theme'), liste = $(zid + '-liste');
      themes.forEach(function (t, i) { var o = document.createElement('option'); o.value = String(i); o.textContent = t.nom; sel.appendChild(o); });
      var marquer = function () { liste.querySelectorAll('.jpe-idees__msg').forEach(function (x) { x.classList.toggle('is-choisi', x.textContent === champ.value.trim()); }); };
      var afficher = function (i) {
        liste.innerHTML = '';
        var lim = champ.maxLength > 0 ? champ.maxLength : 9999;
        themes[i].m.forEach(function (m) {
          if (m.length > lim) return;
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'jpe-idees__msg'; b.textContent = m;
          b.addEventListener('click', function () { champ.value = m; champ.dispatchEvent(new Event('input', { bubbles: true })); marquer(); });
          liste.appendChild(b);
        });
        marquer();
      };
      sel.addEventListener('change', function () { afficher(parseInt(sel.value, 10)); });
      champ.addEventListener('input', marquer);
      afficher(0);
      zone.hidden = false;
      return { maj: function () { afficher(parseInt(sel.value, 10) || 0); } };
    }
    /* Aperçu du logo : on retire les marges vides (transparentes ou de la couleur du fond) pour que le logo soit bien centré sur le pot */
    function rognerLogo(url, cle) {
      cle = cle || 'fichierUrl';
      var img = new Image();
      img.onload = function () {
        try {
          var k = Math.min(1, 600 / Math.max(img.naturalWidth || 300, img.naturalHeight || 300));
          var w = Math.max(1, Math.round((img.naturalWidth || 300) * k)), h = Math.max(1, Math.round((img.naturalHeight || 300) * k));
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          var cx = cv.getContext('2d'); cx.drawImage(img, 0, 0, w, h);
          var px = cx.getImageData(0, 0, w, h), d = px.data;
          var transp = d[3] < 20, fr = d[0], fg = d[1], fb = d[2];
          var fond = function (i) { return transp ? d[i + 3] < 20 : (d[i + 3] < 20 || Math.abs(d[i] - fr) + Math.abs(d[i + 1] - fg) + Math.abs(d[i + 2] - fb) < 40); };
          var x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            if (fond(i)) { if (!transp) d[i + 3] = 0; continue; }
            if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
          if (x1 < 0) return;
          cx.putImageData(px, 0, 0);
          var cw = x1 - x0 + 1, ch = y1 - y0 + 1, out = document.createElement('canvas'); out.width = cw; out.height = ch;
          out.getContext('2d').drawImage(cv, x0, y0, cw, ch, 0, 0, cw, ch);
          var data = out.toDataURL('image/png');
          if (E[cle] !== url) return;
          URL.revokeObjectURL(url); E[cle] = data; tout();
        } catch (e) {}
      };
      img.src = url;
    }
    /* Zoom sur le bon sachet dans les planches photo (01 à 09 sur la 1re, 10 à 17 sur la 2e), d'après le numéro en début de nom : même réglage que le bon de commande revendeurs */
    var PLANCHES = [
      { x: [0.292, 0.509, 0.721], y: [0.131, 0.423, 0.714], ym: [0.177, 0.470, 0.763] },
      { x: [0.278, 0.491, 0.697], y: [0.136, 0.425, 0.717], ym: [0.183, 0.471, 0.764] }
    ], CADRE_S = 0.21;
    function zoomSachet(nom, url, cls) {
      var m = String(nom || '').match(/^\s*(\d{1,2})\b/); if (!m || !url) return '';
      var n = +m[1]; if (!n) return '';
      var P = n <= 9 ? PLANCHES[0] : PLANCHES[1], i = n <= 9 ? n - 1 : (n - 10) % 9, col = i % 3, row = Math.floor(i / 3);
      var cx = P.x[col], cy = (col === 1 ? P.ym : P.y)[row];
      var px = Math.max(0, Math.min(100, (cx - CADRE_S / 2) / (1 - CADRE_S) * 100)), py = Math.max(0, Math.min(100, (cy - CADRE_S / 2) / (1 - CADRE_S) * 100));
      return '<i class="' + cls + '" style="background-image:url(\'' + url.replace(/'/g, '%27') + '\');background-size:' + (100 / CADRE_S).toFixed(1) + '%;background-position:' + px.toFixed(1) + '% ' + py.toFixed(1) + '%"></i>';
    }
    qa('.jpe-sachet[data-grande]').forEach(function (c) {
      var z = zoomSachet(c.dataset.nom, c.dataset.grande, 'jpe-sachet__zoom'), im = c.querySelector('.jpe-sachet__choix img');
      if (z && im) im.outerHTML = z;
    });
    /* Sachets de graines du kit : vignettes avec photo et loupe, synchronisées avec la liste */
    function majSachets() {
      var sel = $('jpe-sachet'); if (!sel) return;
      qa('.jpe-sachet').forEach(function (c) { c.classList.toggle('is-actif', c.dataset.nom === sel.value); });
    }
    (function () {
      var sel = $('jpe-sachet'), cartes = qa('.jpe-sachet'); if (!sel || !cartes.length) return;
      var noms = Array.prototype.map.call(sel.options, function (o) { return o.value; });
      cartes.forEach(function (c) { if (noms.indexOf(c.dataset.nom) < 0) c.remove(); });
      if (!qa('.jpe-sachet').length) return;
      sel.hidden = true;
      R.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.jpe-sachet__choix'); if (!b) return;
        sel.value = b.parentNode.dataset.nom; sel.dispatchEvent(new Event('change', { bubbles: true })); majSachets();
      });
      sel.addEventListener('change', majSachets);
      majSachets();
    })();
    banque('jpe-idees', $('jpe-msg'), cfg.banque);
    banque('jpe-idees-v', $('jpe-vmsg'), cfg.banque);
    var BANQUE_C = banque('jpe-idees-c', $('jpe-cmsg'), cfg.banqueCarte);
    if ($('jpe-sanscoeur')) $('jpe-sanscoeur').addEventListener('change', function () { E.face = 'recto'; tout(); });
    if ($('jpe-sanscoeur-v')) $('jpe-sanscoeur-v').addEventListener('change', function () { E.face = 'verso'; tout(); });
    R.addEventListener('input', function (e) {
      if (['jpe-msg', 'jpe-vmsg', 'jpe-liste', 'jpe-qte', 'jpe-cmsg'].indexOf(e.target.id) > -1) {
        if (e.target.id === 'jpe-vmsg' || e.target.id === 'jpe-liste') E.face = 'verso';
        if (e.target.id === 'jpe-msg') E.face = 'recto';
        if (e.target.id === 'jpe-cmsg' && E.carte) E.face = 'carte';
        cacherErreur(); tout();
      }
    });
    qa('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () { var n = Math.max(minimum(), qte() + parseInt(b.dataset.q, 10)); $('jpe-qte').value = n; cacherErreur(); tout(); });
    });
    qa('[data-face]').forEach(function (b) { b.addEventListener('click', function () { E.face = b.dataset.face; tout(); }); });

    /* ---- Validation et ajout au panier ---- */
    /* Erreur affichée en rouge juste sous le champ concerné (et le champ entouré), la page défile jusqu'à lui */
    function ancreErreur(champ) { return (champ.type === 'file' && champ.closest('.jpe-fichier')) || (champ.closest('.jpe-qte')) || champ; }
    function erreurChamp(msg, champ, sansScroll) {
      qa('.jpe-err').forEach(function (x) { x.remove(); }); qa('.is-err').forEach(function (x) { x.classList.remove('is-err'); });
      var a = ancreErreur(champ), p = document.createElement('p');
      p.className = 'jpe-err'; p.setAttribute('role', 'alert'); p.textContent = msg;
      a.classList.add('is-err'); a.parentNode.insertBefore(p, a.nextSibling);
      if (!sansScroll) { champ.focus({ preventScroll: true }); a.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    }
    function erreur(msg, champ) {
      var z = $('jpe-erreur');
      if (champ && ancreErreur(champ).offsetParent !== null) { z.hidden = true; erreurChamp(msg, champ); return; }
      z.textContent = msg; z.hidden = false; z.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    function cacherErreur() { $('jpe-erreur').hidden = true; qa('.jpe-err').forEach(function (x) { x.remove(); }); qa('.is-err').forEach(function (x) { x.classList.remove('is-err'); }); }
    function siretOk() { var v = $('jpe-siret').value.replace(/[\s.]/g, ''); return !v || /^\d{14}$/.test(v); }
    ['jpe-email', 'jpe-siret'].forEach(function (id) {
      var c = $(id); if (!c) return;
      c.addEventListener('blur', function () {
        if (id === 'jpe-email' && c.value.trim() && !emailOk()) erreurChamp(T('e_email'), c, true);
        if (id === 'jpe-siret' && !siretOk()) erreurChamp(T('e_siret'), c, true);
      });
      c.addEventListener('input', function () { if (c.classList.contains('is-err')) cacherErreur(); });
    });
    /* ---- Prospect : à chaque devis téléchargé ou ajout au panier avec e-mail, Mylène reçoit un récapitulatif
       (formulaire de contact Shopify, rien d'autre n'est stocké) ---- */
    function emailOk() { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test($('jpe-email').value.trim()); }
    var dejaEnvoye = {};
    function prevenir(action) {
      var mail = $('jpe-email').value.trim(); if (!emailOk()) return;
      var corps = action + '\n\n' + recapTexte() + '\nTotal HT : ' + eur(calcTout().tot) + '\n\nSIRET : ' + ($('jpe-siret').value.trim() || 'non indiqué') + '\nPage : ' + location.href.split('?')[0];
      if (dejaEnvoye[corps]) return; dejaEnvoye[corps] = 1;
      var fd = new FormData();
      fd.append('form_type', 'contact'); fd.append('utf8', '✓');
      fd.append('contact[email]', mail);
      fd.append('contact[name]', $('jpe-ent').value.trim());
      fd.append('contact[Origine]', 'Cadeau d\'entreprise, ' + action);
      fd.append('contact[body]', corps);
      try { fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'contact', { method: 'POST', body: fd, credentials: 'same-origin', keepalive: true }).catch(function () {}); } catch (e) {}
    }
    /* la ligne en cours est complète ? */
    function validerLigne(sansFichier) {
      if ((estCarte() || E.carte || E.logo) && qte() > 0 && qte() < (cfg.min || 1)) return erreur(T('e_min_serie', { n: cfg.min }), $('jpe-qte')), false;
      if (estCarte()) { if (!$('jpe-cmsg').value.trim()) return erreur(T('e_carte'), $('jpe-cmsg')), false; return true; }
      if (!sansFichier && E.logo && !($('jpe-fichier').files && $('jpe-fichier').files.length)) return erreur(T('e_logo'), $('jpe-fichier')), false;
      if (!E.logo && !$('jpe-msg').value.trim()) return erreur(T('e_msg'), $('jpe-msg')), false;
      if (E.verso && (E.vmode === 'meme' ? !$('jpe-vmsg').value.trim() : !prenoms().length)) return erreur(T('e_verso'), E.vmode === 'meme' ? $('jpe-vmsg') : $('jpe-liste')), false;
      if (E.carte && !$('jpe-cmsg').value.trim()) return erreur(T('e_carte'), $('jpe-cmsg')), false;
      return true;
    }
    function valider() {
      var K = calcTout();
      if ((!SEL.length || qte() > 0) && !validerLigne()) return false;
      if (K.qtot < resteMin()) return erreur(T('e_min', { n: cfg.min }), $('jpe-qte')), false;
      if (!SEL.length && qte() < minimum()) return erreur(T('e_min', { n: minimum() }), $('jpe-qte')), false;
      if (K.items.some(function (it) { return it.sn.logo; }) && !($('jpe-fichier').files && $('jpe-fichier').files.length)) return erreur(T('e_logo'), $('jpe-fichier')), false;
      return true;
    }
    /* propriétés de panier d'une ligne de la sélection */
    function propsDe(sn) {
      var p = {}, ent = $('jpe-ent').value.trim();
      if (sn.C) { p['Message de la carte'] = sn.ct; if (sn.cs) p['Écriture'] = sn.cs; }
      else {
        if (!sn.logo) { p['Message recto'] = sn.t; if (sn.nc) p['Sans cœur'] = 'Oui'; } else p['Couleur du logo'] = estTerraDe(sn) ? 'Blanc (terre cuite)' : 'En couleurs';
        if (sn.verso && sn.vnc) p['Sans cœur au dos'] = 'Oui';
        if (sn.verso) { if (sn.vmode === 'liste') p['Prénoms au verso'] = sn.pr.join(', ') || 'liste à envoyer'; else p['Message verso'] = sn.vt; }
        if (sn.s) p['Sachet de graines'] = sn.s;
      }
      if (ent) p.Entreprise = ent;
      if (dateEv()) p['Date de l\'événement'] = dateEv();
      if ($('jpe-siret').value.trim()) p.SIRET = $('jpe-siret').value.trim();
      if ($('jpe-po').value.trim()) p['N° de bon de commande'] = $('jpe-po').value.trim();
      if (emailOk()) p['E-mail'] = $('jpe-email').value.trim();
      return p;
    }
    function ajoutCarte(id, n, props) {
      var lf = logoCarteFichier();
      if (!lf) return postJson([{ id: id, quantity: n, properties: props }]);
      var fd = new FormData(); fd.append('id', id); fd.append('quantity', n);
      Object.keys(props).forEach(function (x) { if (props[x]) fd.append('properties[' + x + ']', props[x]); });
      fd.append('properties[Logo sur la carte]', 'Oui, en noir'); fd.append('properties[Logo carte]', lf);
      return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r; });
    }
    function nettoyer(items) { items.forEach(function (it) { if (it.properties) Object.keys(it.properties).forEach(function (k) { if (it.properties[k] === '' || it.properties[k] == null) delete it.properties[k]; }); }); return items; }
    function postJson(items) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: nettoyer(items) }) }).then(function (r) { if (!r.ok) throw r; return r; }); }
    function ajouterSelection(btn, txt, aller) {
      var K = calcTout(), ent = $('jpe-ent').value.trim(), fichier = $('jpe-fichier').files && $('jpe-fichier').files[0], chaine = Promise.resolve();
      K.items.forEach(function (it) {
        chaine = chaine.then(function () {
          if (!it.v) return;
          var pr = propsDe(it.sn);
          if (it.sn.logo && fichier) {
            var fd = new FormData(); fd.append('id', it.v.id); fd.append('quantity', it.sn.q);
            Object.keys(pr).forEach(function (x) { fd.append('properties[' + x + ']', pr[x]); }); fd.append('properties[Logo]', fichier);
            return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) throw r; });
          }
          return postJson([{ id: it.v.id, quantity: it.sn.q, properties: pr }]);
        }).then(function () {
          if (it.co) return ajoutCarte(it.co.id, it.sn.q, { 'Message de la carte': it.sn.ct, 'Écriture': it.sn.cs, 'Entreprise': ent });
        });
      });
      chaine.then(function () { if (K.forf) return postJson([{ id: cfg.forfait.id, quantity: 1, properties: { 'Entreprise': ent } }]); })
        .then(function () { SEL = []; sauverSel(); aller(); })
        .catch(function () { btn.disabled = false; btn.textContent = txt; erreur(T('e_panier')); });
    }
    /* « + Ajouter un autre modèle » */
    $('jpe-sel-ajout').addEventListener('click', function () {
      cacherErreur();
      if (qte() < 1) return erreur(T('e_qte_ligne'), $('jpe-qte'));
      if (!validerLigne()) return;
      SEL.push(snap()); sauverSel();
      $('jpe-qte').value = ''; $('jpe-qte').readOnly = false;
      tout();
      var ok = $('jpe-sel-ok'); ok.hidden = false; clearTimeout(ok.t); ok.t = setTimeout(function () { ok.hidden = true; }, 6000);
      var e1 = $('jpe-modeles'); if (e1) e1.closest('fieldset').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    function proprietes(fd) {
      var p = function (k, v) { if (v) fd.append('properties[' + k + ']', v); };
      if (!E.logo) p('Message recto', $('jpe-msg').value.trim());
      else p('Couleur du logo', estTerra() ? 'Blanc (terre cuite)' : 'En couleurs');
      if (E.verso) p(E.vmode === 'liste' ? 'Prénoms au verso' : 'Message verso', E.vmode === 'liste' ? prenoms().join(', ') : $('jpe-vmsg').value.trim());
      if (typeModele(E.m) === 'kit') p('Sachet de graines', $('jpe-sachet').value);
      if (!E.logo && sansCoeur()) p('Sans cœur', 'Oui');
      if (E.verso && sansCoeurV()) p('Sans cœur au dos', 'Oui');
    }
    $('jpe-form').addEventListener('submit', function (e) {
      e.preventDefault();
      if (!valider()) return;
      prevenir('Ajout au panier');
      var btn = $('jpe-ajout'), txt = btn.textContent; btn.disabled = true; btn.textContent = T('t_ajout');
      var aller = function () { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart'; };
      if (SEL.length) return ajouterSelection(btn, txt, aller);
      if (estCarte()) {
        var cc = carteChoisie(), pr = { 'Message de la carte': $('jpe-cmsg').value.trim(), 'Écriture': (q('input[name="jpe-cstyle"]:checked') || {}).value || '', 'Entreprise': $('jpe-ent').value.trim() };
        if ($('jpe-siret').value.trim()) pr.SIRET = $('jpe-siret').value.trim();
        if (emailOk()) pr['E-mail'] = $('jpe-email').value.trim();
        if ($('jpe-po').value.trim()) pr['N° de bon de commande'] = $('jpe-po').value.trim();
        ajoutCarte(cc.id, qte(), pr)
          .then(function () { aller(); })
          .catch(function () { btn.disabled = false; btn.textContent = txt; erreur(T('e_panier')); });
        return;
      }
      var form = $('jpe-form'), fd = new FormData(form);
      proprietes(fd);
      if (!emailOk()) fd.delete('properties[E-mail]');
      if (!E.logo) fd.delete('properties[Logo]');
      if (!$('jpe-siret').value.trim()) fd.delete('properties[SIRET]');
      if (!$('jpe-ent').value.trim()) fd.delete('properties[Entreprise]');
      if (!$('jpe-po').value.trim()) fd.delete('properties[N° de bon de commande]');
      var n = qte(), ent = $('jpe-ent').value.trim(), extras = [], principalOk = false;
      var c = carteChoisie();
      var carteAvecLogo = c && logoCarteFichier(), propsC = c ? { 'Message de la carte': $('jpe-cmsg').value.trim(), 'Écriture': (q('input[name="jpe-cstyle"]:checked') || {}).value || '', 'Entreprise': ent } : null;
      if (c && !carteAvecLogo) extras.push({ id: c.id, quantity: n, properties: propsC });
      if (E.logo && cfg.forfait && !E.forfaitPanier) extras.push({ id: cfg.forfait.id, quantity: 1, properties: { 'Entreprise': ent } });
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { principalOk = true; return extras.length ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: nettoyer(extras) }) }) : null; })
        .then(function () { return carteAvecLogo ? ajoutCarte(c.id, n, propsC) : null; })
        .then(function () { window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart'; })
        .catch(function () {
          if (principalOk) { btn.disabled = false; btn.textContent = txt; erreur(T('e_panier')); return; }
          /* Plan B : envoi classique du formulaire (fichier compris), après les cartes et le forfait */
          var fin = function () {
            form.querySelectorAll('input[data-jpe-plus]').forEach(function (x) { x.remove(); });
            var ajout = new FormData(); proprietes(ajout);
            ajout.forEach(function (v, k) { var h = document.createElement('input'); h.type = 'hidden'; h.name = k; h.value = v; h.setAttribute('data-jpe-plus', ''); form.appendChild(h); });
            if (!$('jpe-siret').value.trim()) $('jpe-siret').disabled = true;
            if (!$('jpe-po').value.trim()) $('jpe-po').disabled = true;
            if (!emailOk()) $('jpe-email').disabled = true;
            if (!E.logo) $('jpe-fichier').disabled = true;
            HTMLFormElement.prototype.submit.call(form);
          };
          if (!extras.length) return fin();
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: nettoyer(extras) }) })
            .then(fin, function () { btn.disabled = false; btn.textContent = txt; erreur(T('e_panier')); });
        });
    });

    /* ---- Au-delà du maximum : la demande part par le formulaire « Projet sur mesure » ---- */
    /* Écrire à Mylène : le formulaire « Projet sur mesure » de la page, ou à défaut une fenêtre avec un formulaire de contact Shopify (jamais de mailto) */
    function ouvrirContact(texte, qteTxt) {
      var msg = document.getElementById('jpe-p-msg'), ent = document.getElementById('jpe-p-ent'), pq = document.getElementById('jpe-p-qte');
      if (ent && !ent.value) ent.value = $('jpe-ent').value;
      if (pq && qteTxt) pq.value = qteTxt;
      if (msg && texte) msg.value = texte;
      var fen = document.getElementById('jpe-contact');
      if (fen) {
        if (fen.parentNode !== document.body) { var cs = getComputedStyle(R); ['--jpe-acc', '--jpe-fond', '--jpe-tx', '--jpe-doux', '--jpe-ligne', '--jpe-titre', '--jpe-machine', '--jpe-terra', '--jpe-carte', '--jpe-r'].forEach(function (k) { var v = cs.getPropertyValue(k).trim(); if (v) fen.style.setProperty(k, v); }); document.body.appendChild(fen); }
        fen.hidden = false; bloquerPage(true);
        setTimeout(function () { var c = fen.querySelector('input[name="contact[name]"]'); if (c) c.focus(); }, 50);
        return;
      }
      var sec = document.getElementById('jpe-projet');
      if (sec) { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(function () { if (msg) msg.focus({ preventScroll: true }); }, 600); }
    }
    (function () {
      var fen = document.getElementById('jpe-contact'); if (!fen) return;
      var fermer = function () { fen.hidden = true; bloquerPage(false); };
      fen.addEventListener('click', function (e) { if (e.target === fen || e.target.closest('.jpe-fen__x')) fermer(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !fen.hidden) fermer(); });
      if (fen.querySelector('[data-jpe-envoye], .jpe-erreur')) ouvrirContact('');
    })();
    /* Les liens mailto: de la page ouvrent le formulaire (le sujet du lien devient le début du message) */
    R.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="mailto:"]'); if (!a) return;
      e.preventDefault();
      var m = a.getAttribute('href').match(/[?&]subject=([^&]*)/), sujet = m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
      ouvrirContact(sujet ? sujet + ' : ' : '');
    });
    $('jpe-devis').addEventListener('click', function (e) {
      e.preventDefault();
      ouvrirContact('Bonjour, je souhaite un devis pour :\n' + recapTexte() + '\n\n', String(qte()));
    });

    /* ---- Devis PDF (généré dans le navigateur) ---- */
    var DV = cfg.devis || {};
    function chargerPdf() {
      if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
      return new Promise(function (ok, ko) {
        var sc = document.createElement('script'); sc.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
        sc.onload = function () { window.jspdf ? ok(window.jspdf.jsPDF) : ko(); }; sc.onerror = ko; document.head.appendChild(sc);
      });
    }
    function logoData(url) {
      return new Promise(function (ok) {
        if (!url) return ok(null);
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () { try { var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight; c.getContext('2d').drawImage(im, 0, 0); ok({ data: c.toDataURL('image/png'), ratio: im.naturalWidth / im.naturalHeight }); } catch (e) { ok(null); } };
        im.onerror = function () { ok(null); };
        im.src = (url.indexOf('//') === 0 ? 'https:' : '') + url;
        setTimeout(function () { ok(null); }, 5000);
      });
    }
    function pdfTxt(t) { return String(t == null ? '' : t).replace(/[  ]/g, ' ').replace(/[^\x00-\xFF€œŒ’‘“”…–•]/g, '').trim(); }
    function dateFr(d) { return String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear(); }
    function lienDevis() {
      var L = lignesTout();
      if (L.length > 1) {
        var mini = L.map(function (sn) { return { C: sn.C ? 1 : 0, m: sn.m, f: sn.f, l: sn.logo ? 1 : 0, v: sn.verso ? (sn.vmode === 'liste' ? 'liste' : 'meme') : '', t: sn.t, nc: sn.nc ? 1 : 0, vt: sn.vt, c: sn.carte, ct: sn.ct, cs: sn.cs, s: sn.s, q: sn.q }; });
        return (cfg.url || location.href.split('?')[0].split('#')[0]) + '?jpe_sel=' + encodeURIComponent(JSON.stringify(mini)) + '&jpe_e=' + encodeURIComponent($('jpe-ent').value.trim()) + ($('jpe-po').value.trim() ? '&jpe_po=' + encodeURIComponent($('jpe-po').value.trim()) : '') + (evBrut() ? '&jpe_ev=' + evBrut() : '') + '#jpe-config';
      }
      var p = { m: E.m, f: E.f || '', r: E.logo ? 'logo' : 'message', v: E.verso ? (E.vmode === 'liste' ? 'liste' : 'meme') : '', q: qte(), c: E.carte || '', e: $('jpe-ent').value.trim(), ev: evBrut() };
      if (!E.logo) { p.t = $('jpe-msg').value; if (sansCoeur()) p.nc = 1; } if (E.verso && sansCoeurV()) p.vnc = 1; if (E.verso && E.vmode === 'meme') p.vt = $('jpe-vmsg').value; if (E.carte) { p.ct = $('jpe-cmsg').value; p.cs = (q('input[name="jpe-cstyle"]:checked') || {}).value || ''; }
      if (typeModele(E.m) === 'kit') p.s = $('jpe-sachet').value;
      return (cfg.url || location.href.split('?')[0].split('#')[0]) + '?' + Object.keys(p).filter(function (k) { return p[k] !== ''; }).map(function (k) { return 'jpe_' + k + '=' + encodeURIComponent(p[k]); }).join('&') + '#jpe-config';
    }
    function devisPdf(JsPDF, logo) {
      var k = calcTout(), now = new Date(), doc = new JsPDF({ unit: 'mm', format: 'a4' }), W = 210, M = 16, y;
      var VERT = [12, 56, 28], TERRA = [173, 82, 63], GRIS = [111, 98, 90], NOIR = [42, 33, 28], CREME = [251, 244, 234];
      var num = 'E' + now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + '-' + String(now.getHours()).padStart(2, '0') + String(now.getMinutes()).padStart(2, '0');
      var valid = parseInt(DV.validite, 10) || 30, fin = new Date(now); fin.setDate(fin.getDate() + valid);
      function txt(t, x, yy, o) { doc.text(pdfTxt(t), x, yy, o || {}); }
      function couleur(c) { doc.setTextColor(c[0], c[1], c[2]); }
      var e2 = function (n) { return eur(n).replace(/ /g, ' '); };
      var yEnt = 28;
      if (logo) { var lh = 16, lw = Math.min(70, lh * logo.ratio); lh = lw / logo.ratio; doc.addImage(logo.data, 'PNG', M, 9, lw, lh); yEnt = 9 + lh + 5; doc.setFont('helvetica', 'bold'); doc.setFontSize(9); couleur(NOIR); txt(DV.nom || 'Joli Pot', M, yEnt); yEnt += 4.5; }
      else { doc.setFont('helvetica', 'bold'); doc.setFontSize(22); couleur(VERT); txt(DV.nom || 'Joli Pot', M, 22); }
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); couleur(GRIS);
      var ent = [DV.adresse, DV.siret ? 'SIRET ' + DV.siret : '', DV.tva ? 'TVA intracommunautaire ' + DV.tva : '', cfg.email || ''].filter(Boolean);
      ent.forEach(function (l, i) { txt(l, M, yEnt + i * 4); });
      doc.setFont('helvetica', 'bold'); doc.setFontSize(22); couleur(TERRA); txt('DEVIS', W - M, 22, { align: 'right' });
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); couleur(NOIR);
      txt('N° ' + num, W - M, 28, { align: 'right' }); txt('Date : ' + dateFr(now), W - M, 32, { align: 'right' }); txt("Valable jusqu'au " + dateFr(fin), W - M, 36, { align: 'right' });
      y = Math.max(44, yEnt + ent.length * 4 + 4);
      var cli = [$('jpe-ent').value.trim(), $('jpe-siret').value.trim() ? 'SIRET ' + $('jpe-siret').value.trim() : '', $('jpe-po').value.trim() ? 'Bon de commande n° ' + $('jpe-po').value.trim() : '', dateEv() ? 'Événement le ' + dateEv() : '', $('jpe-email').value.trim()].filter(Boolean);
      var hc = 9 + cli.length * 4.3;
      doc.setFillColor(CREME[0], CREME[1], CREME[2]); doc.roundedRect(108, y, W - M - 108, hc, 2, 2, 'F');
      doc.setFontSize(7.5); couleur(GRIS); txt('CLIENT', 113, y + 6);
      doc.setFontSize(9); couleur(NOIR); cli.forEach(function (l, i) { doc.setFont('helvetica', i === 0 ? 'bold' : 'normal'); txt(l, 113, y + 11 + i * 4.3); });
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); couleur(NOIR);
      txt("Cadeau d'entreprise personnalisé, prix hors taxes", M, y + 6);
      y = y + hc + 8;
      var X = { q: 140, pu: 166, tot: W - M };
      doc.setFillColor(VERT[0], VERT[1], VERT[2]); doc.rect(M, y, W - 2 * M, 8, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5); doc.setTextColor(255, 255, 255);
      txt('Désignation', M + 3, y + 5.3); txt('Qté', X.q, y + 5.3, { align: 'right' }); txt('PU HT', X.pu, y + 5.3, { align: 'right' }); txt('Total HT', X.tot - 3, y + 5.3, { align: 'right' }); y += 8;
      var lignes = [], K = calcTout();
      K.items.forEach(function (it) {
        lignes.push([it.nom, it.sn.C ? it.det : it.det.split(' · ' + T('m_carte_nom'))[0], it.sn.q, it.u]);
        if (it.co) lignes.push([T('m_carte_nom') + ', ' + it.co.t, 'Message : « ' + it.sn.ct + ' »' + (it.sn.cs ? ' · ' + it.sn.cs : ''), it.sn.q, it.cu]);
      });
      if (K.r) lignes.push(['Remise quantité -' + String(K.r).replace('.', ',') + ' % sur les pots', '', '', -(K.brutPots - K.sousPots), true]);
      if (K.forf) lignes.push([T('t_forfait'), 'BAT envoyé par e-mail avant la fabrication', 1, K.forf]);
      lignes.forEach(function (l, i) {
        var l1 = doc.splitTextToSize(pdfTxt(l[0]), 108), l2 = l[1] ? doc.splitTextToSize(pdfTxt(l[1]), 108) : [];
        var h = 4 + (l1.length + l2.length) * 4;
        if (y + h > 262) { doc.addPage(); y = 20; }
        if (i % 2) { doc.setFillColor(CREME[0], CREME[1], CREME[2]); doc.rect(M, y, W - 2 * M, h, 'F'); }
        doc.setFontSize(9); couleur(l[4] ? TERRA : NOIR); doc.setFont('helvetica', 'bold');
        l1.forEach(function (t, j) { doc.text(t, M + 3, y + 5 + j * 4); });
        doc.setFont('helvetica', 'normal'); couleur(GRIS); l2.forEach(function (t, j) { doc.text(t, M + 3, y + 5 + (l1.length + j) * 4); });
        couleur(l[4] ? TERRA : NOIR);
        if (l[4]) txt(e2(l[3]), X.tot - 3, y + 5, { align: 'right' });
        else { txt(String(l[2]), X.q, y + 5, { align: 'right' }); txt(e2(l[3]), X.pu, y + 5, { align: 'right' }); txt(e2(l[2] * l[3]), X.tot - 3, y + 5, { align: 'right' }); }
        y += h;
      });
      if (y + 40 > 270) { doc.addPage(); y = 20; }
      y += 6;
      var tva = k.tot * (TVA - 1);
      [['Total HT', e2(k.tot)], ['Livraison', k.tot >= 500 ? 'offerte (une adresse)' : 'calculée à la commande'], ['TVA 20 %', e2(tva)]].forEach(function (t) { doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5); couleur(NOIR); txt(t[0], 150, y, { align: 'right' }); txt(t[1], X.tot - 3, y, { align: 'right' }); y += 5.5; });
      doc.setFillColor(VERT[0], VERT[1], VERT[2]); doc.rect(110, y - 3.5, W - M - 110, 9, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(255, 255, 255);
      txt('Total TTC', 150, y + 2.5, { align: 'right' }); txt(e2(k.tot + tva), X.tot - 3, y + 2.5, { align: 'right' });
      y += 14;
      var cond = String(DV.conditions || '').split(/\n/).map(function (x) { return x.trim(); }).filter(Boolean);
      var liv = dateLivraison(); if (liv) cond.push('Livraison estimée en France vers le ' + dateFr(liv) + ' pour une commande passée le ' + dateFr(now) + ', si le BAT est validé sous 48 h.');
      cond.push('Devis valable ' + valid + " jours, jusqu'au " + dateFr(fin) + '.');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(9); couleur(VERT); txt('Conditions', M, y); y += 5;
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.3); couleur(NOIR);
      cond.forEach(function (c) { doc.splitTextToSize(pdfTxt(c), W - 2 * M).forEach(function (t) { if (y > 275) { doc.addPage(); y = 20; } doc.text(t, M, y); y += 3.9; }); y += 1.2; });
      y += 3; if (y > 270) { doc.addPage(); y = 20; }
      doc.setFont('helvetica', 'bold'); doc.setFontSize(9.5); couleur(TERRA);
      var lt = pdfTxt(T('t_devis_lien')); doc.textWithLink(lt, M, y, { url: lienDevis() });
      doc.setDrawColor(TERRA[0], TERRA[1], TERRA[2]); doc.setLineWidth(0.3); doc.line(M, y + 1, M + doc.getTextWidth(lt), y + 1);
      var nbp = doc.getNumberOfPages();
      for (var pg = 1; pg <= nbp; pg++) { doc.setPage(pg); doc.setDrawColor(221, 209, 194); doc.setLineWidth(0.2); doc.line(M, 284, W - M, 284); doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); couleur(GRIS); txt([DV.nom || 'Joli Pot', DV.adresse, DV.siret ? 'SIRET ' + DV.siret : '', DV.tva ? 'TVA ' + DV.tva : ''].filter(Boolean).join(' · '), M, 289); txt(pg + ' / ' + nbp, W - M, 289, { align: 'right' }); }
      var slug = $('jpe-ent').value.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'entreprise';
      var nom = 'Devis-Joli-Pot-' + slug + '-' + num + '.pdf';
      doc.save(nom);
      return nom;
    }
    /* Coordonnées : demandées seulement pour le devis (ou si le client veut ajouter un n° de bon de commande) */
    function ouvrirCoord(focus) {
      var c = $('jpe-coord'); if (!c) return;
      c.hidden = false; if ($('jpe-coord-lien')) $('jpe-coord-lien').hidden = true; $('jpe-devis-pdf').hidden = true;
      if (focus) { c.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { $('jpe-ent').focus({ preventScroll: true }); }, 350); }
    }
    if ($('jpe-coord-lien')) $('jpe-coord-lien').addEventListener('click', function () { ouvrirCoord(true); });
    $('jpe-devis-pdf').addEventListener('click', function () {
      if ($('jpe-coord') && $('jpe-coord').hidden) { cacherErreur(); ouvrirCoord(true); return; }
      $('jpe-devis-go').click();
    });
    $('jpe-devis-go').addEventListener('click', function () {
      if ((!SEL.length || qte() > 0) && !validerLigne(true)) return;
      if (calcTout().qtot < resteMin()) return erreur(T('e_min', { n: cfg.min }), $('jpe-qte'));
      if (!SEL.length && qte() < minimum()) return erreur(T('e_min', { n: minimum() }), $('jpe-qte'));
      if (!$('jpe-ent').value.trim()) return erreur(T('e_entreprise'), $('jpe-ent'));
      if (!emailOk()) return erreur(T('e_email'), $('jpe-email'));
      if (!siretOk()) return erreur(T('e_siret'), $('jpe-siret'));
      cacherErreur();
      prevenir('Devis PDF téléchargé');
      var btn = this, base = btn.textContent; btn.disabled = true; btn.textContent = T('t_devis_attente');
      Promise.all([chargerPdf(), logoData(DV.logo)]).then(function (x) { window.jpeDernierDevis = devisPdf(x[0], x[1]); })
        .catch(function () { erreur(T('e_devis')); }).then(function () { btn.disabled = false; btn.textContent = base; });
    });

    /* ---- Reprise d'un devis (lien du PDF) ---- */
    (function () {
      var p = {}; location.search.replace(/^\?/, '').split('&').forEach(function (x) { var a = x.split('='); if (a[0].indexOf('jpe_') === 0) p[a[0].slice(4)] = decodeURIComponent((a[1] || '').replace(/\+/g, ' ')); });
      if (p.sel) {
        try {
          SEL = JSON.parse(p.sel).map(function (x) { return { C: !!x.C, m: x.m, f: x.f || '', logo: !!x.l, verso: !!x.v, vmode: x.v === 'liste' ? 'liste' : 'meme', t: x.t || '', vt: x.vt || '', pr: [], carte: x.c || '', ct: x.ct || '', cs: x.cs || '', s: x.s || '', q: parseInt(x.q, 10) || 0 }; })
            .filter(function (sn) { return sn.q > 0 && (sn.C || modeles.indexOf(sn.m) > -1); });
          sauverSel(); $('jpe-qte').value = '';
        } catch (e) {}
        if (p.e) { $('jpe-ent').value = p.e; ouvrirCoord(false); }
        if (p.po) $('jpe-po').value = p.po;
        remettreEv(p.ev);
        tout(); return;
      }
      if (!p.m) return;
      var radio = function (name, val) { var r = q('input[name="' + name + '"][value="' + String(val).replace(/"/g, '') + '"]'); if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } };
      if (modeles.indexOf(p.m) < 0) p.m = modeles.filter(function (x) { return petit(x) === petit(p.m); })[0] || p.m;
      radio('jpe-modele', p.m);
      if (p.f) radio('jpe-fin', p.f);
      if (p.r) radio('jpe-recto', p.r);
      if (p.t) $('jpe-msg').value = p.t;
      if ($('jpe-sanscoeur')) $('jpe-sanscoeur').checked = !!p.nc;
      if ($('jpe-sanscoeur-v')) $('jpe-sanscoeur-v').checked = !!p.vnc;
      if (p.v) { radio('jpe-verso', 'oui'); radio('jpe-vmode', p.v); if (p.vt) $('jpe-vmsg').value = p.vt; }
      if (p.c) radio('jpe-carte', p.c);
      if (p.ct) $('jpe-cmsg').value = p.ct;
      if (p.cs) radio('jpe-cstyle', p.cs);
      if (p.s && $('jpe-sachet')) $('jpe-sachet').value = p.s; majSachets();
      if (p.q) $('jpe-qte').value = p.q;
      if (p.e) { $('jpe-ent').value = p.e; ouvrirCoord(false); }
      if (p.po) $('jpe-po').value = p.po;
      remettreEv(p.ev);
      tout();
    })();

    /* ---- Panier existant (minimum et forfait déjà comptés) ---- */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var ids = V.map(function (v) { return v.id; });
      (c.items || []).forEach(function (it) {
        var echant = it.properties && it.properties['Échantillon'];
        if (ids.indexOf(it.variant_id) > -1 && !echant) E.dejaPanier += it.quantity;
        if (cfg.forfait && it.variant_id === cfg.forfait.id) E.forfaitPanier = true;
        if (!echant && cfg.carte && cfg.carte.some(function (c) { return c.id === it.variant_id; })) E.dejaCartes += it.quantity;
      });
      if (E.dejaPanier && qte() < minimum()) $('jpe-qte').value = minimum();
      tout();
    }).catch(function () {});

    /* ---- Date limite ---- */
    var lim = String(cfg.limite || '').match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (lim && TX.t_limite) {
      var fin = new Date(+lim[3], +lim[2] - 1, +lim[1], 23, 59, 59);
      if (new Date() <= fin) {
        var mois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
        var z = $('jpe-limite'); z.textContent = T('t_limite', { date: (+lim[1] === 1 ? '1er' : +lim[1]) + ' ' + mois[+lim[2] - 1] }); z.hidden = false;
      }
    }

    /* ---- Fiche produit (loupe sur la vignette) : photos, aperçu, infos ---- */
    var FEN = document.getElementById('jpe-fen-' + cfg.racine.replace('jpe-', ''));
    if (FEN) document.body.appendChild(FEN); /* hors des sections à fond, pour rester au-dessus de tout */
    if (FEN) { var csR = getComputedStyle(R); ['--jpe-acc', '--jpe-ligne', '--jpe-tx', '--jpe-doux', '--jpe-fond', '--jpe-carte', '--jpe-titre'].forEach(function (k) { var v = csR.getPropertyValue(k).trim(); if (v) FEN.style.setProperty(k, v); }); }
    var FICHES = petit(cfg.fiches || '').split(/\n/).map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); })
      .filter(function (p) { return p.length >= 3 && p[0] && p[1]; }).map(function (p) { return { k: p[0].toLowerCase(), t: p[1], x: p.slice(2).join(' | ') }; });
    var MOTS = { mini: /(mini|petit) ?pot/i, bougie: /bougie/i, flora: /flora/i, kit: /kit/i, carte: /carte/i };
    var focusAvant = null, choixFiche = null;
    function fermerFiche() { if (!FEN || FEN.hidden) return; FEN.hidden = true; bloquerPage(false); if (focusAvant && focusAvant.isConnected) focusAvant.focus(); }
    function ouvrirFiche(type, valeur, carteEl) {
      if (!FEN) return;
      var lab = carteEl.closest('.jpe-modele') || (q('.jpe-modele input[value="' + String(valeur).replace(/"/g, '') + '"]') || carteEl).closest('.jpe-modele') || carteEl;
      var complement = carteEl.dataset.complement === '1';
      var nom = lab.querySelector('.jpe-modele__txt strong'), desc = lab.querySelector('.jpe-modele__txt small'), prix = lab.querySelector('.jpe-modele__txt em');
      var vues = [];
      if (type === 'carte') vues.push({ html: dessinCarte({ txt: $('jpe-cmsg').value || T('t_carte_msg'), style: (q('input[name="jpe-cstyle"]:checked') || {}).value, logo: logoCarteUrl() }), carte: true });
      else {
        var meme = E.m === valeur, fs = finitionsDe(valeur);
        var po = { t: type, f: meme ? E.f : fs[0], logo: meme ? E.logo : false, url: meme ? E.fichierUrl : null, pdf: meme && E.fichierPdf, txt: (meme && $('jpe-msg').value) || T('t_msg_ph'), nc: meme && sansCoeur(), face: 'recto' };
        vues.push({ html: dessin(po), po: po });
        if (!po.logo) {
          chargerPolice();
          if (document.fonts && document.fonts.load) document.fonts.load('20px "Sacramento"').then(function () {
            if (FEN.hidden || !vues[0].po) return; CTX_M = null; vues[0].html = dessin(vues[0].po);
            var b0 = vign.querySelector('button'); if (b0) b0.innerHTML = vues[0].html;
            if (grande.classList.contains('is-dessin')) grande.innerHTML = vues[0].html;
          }, function () {});
        }
      }
      var vu = {};
      [(cfg.photosG || {})[type]].concat(type === 'carte' ? (cfg.cartePhotos || []) : []).concat((cfg.medias || []).filter(function (x) { return MOTS[type] && MOTS[type].test(x.a || ''); }).map(function (x) { return x.u; }))
        .forEach(function (u) { if (u && !vu[u]) { vu[u] = 1; vues.push({ url: u }); } });
      var grande = FEN.querySelector('.jpe-galerie__grande'), vign = FEN.querySelector('.jpe-galerie__vign');
      function voir(i) {
        var v = vues[i];
        grande.innerHTML = v.html || '<img src="' + v.url + '" alt="' + esc(nom ? nom.textContent : '') + '">';
        grande.classList.toggle('is-dessin', !!v.html);
        if (v.carte) ajusterCarte(grande.querySelector('.jpe-ca'));
        vign.querySelectorAll('button').forEach(function (b, j) { b.classList.toggle('is-actif', j === i); });
      }
      vign.innerHTML = '';
      if (vues.length > 1) vues.forEach(function (v, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Vue ' + (i + 1));
        b.innerHTML = v.url ? '<img src="' + v.url + '" alt="" loading="lazy">' : (v.carte ? dessinCarte({ mini: true }) : v.html);
        b.addEventListener('click', function () { voir(i); }); vign.appendChild(b);
      });
      FEN.querySelector('.jpe-fen__t').textContent = nom ? nom.textContent : '';
      FEN.querySelector('.jpe-fen__desc').textContent = desc ? desc.textContent : '';
      FEN.querySelector('.jpe-fen__prix').textContent = prix ? prix.textContent : '';
      FEN.querySelector('.jpe-infos').innerHTML = FICHES.filter(function (f) { return f.k === type || f.k === 'tous'; })
        .map(function (f) { return '<div><dt>' + esc(f.t) + '</dt><dd>' + esc(f.x) + '</dd></div>'; }).join('');
      choixFiche = complement ? null : valeur;
      var bch = FEN.querySelector('.jpe-fen__choisir'); if (bch) bch.hidden = complement;
      focusAvant = document.activeElement;
      FEN.hidden = false; bloquerPage(true);
      voir(0); requestAnimationFrame(function () { vign.querySelectorAll('.jpe-ca').forEach(ajusterCarte); });
      FEN.querySelector('.jpe-fen__x').focus();
    }
    if (FEN) {
      FEN.addEventListener('click', function (e) {
        if (e.target === FEN || e.target.closest('.jpe-fen__x')) return fermerFiche();
        if (e.target.closest('.jpe-fen__choisir')) {
          var r = q('input[name="jpe-modele"][value="' + String(choixFiche).replace(/"/g, '\\"') + '"]');
          fermerFiche();
          if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermerFiche(); });
    }
    R.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.jpe-loupe[data-fiche]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      ouvrirFiche(b.dataset.fiche, b.dataset.valeur, b);
    }, true);


    /* ---- Barre collante en bas (même principe que le configurateur particuliers) : total à jour, filet livraison offerte,
       bouton « Finaliser » dès que la sélection est complète, qui amène aux boutons panier / devis / autre modèle ---- */
    var BARRE = null, actionsVues = false, configVue = false;
    function lignePrete() {
      if ((estCarte() || E.carte || E.logo) && qte() > 0 && qte() < (cfg.min || 1)) return false;
      if (estCarte()) return !!$('jpe-cmsg').value.trim();
      if (E.logo && !($('jpe-fichier').files && $('jpe-fichier').files.length)) return false;
      if (!E.logo && !$('jpe-msg').value.trim()) return false;
      if (E.verso && (E.vmode === 'meme' ? !$('jpe-vmsg').value.trim() : !prenoms().length)) return false;
      if (E.carte && !$('jpe-cmsg').value.trim()) return false;
      return true;
    }
    function creerBarre() {
      if (BARRE) return BARRE;
      BARRE = document.createElement('div');
      BARRE.className = 'jpe-barre';
      BARRE.innerHTML = '<span class="jpe-barre__fil"><i></i></span><div class="jpe-barre__in"><div class="jpe-barre__prix"><small class="jpe-barre__t"></small><strong></strong><small class="jpe-barre__liv"></small></div><button type="button" class="jpe-barre__btn" hidden></button></div>';
      document.body.appendChild(BARRE);
      ['--jpe-acc', '--jpe-terra', '--jpe-ligne', '--jpe-machine'].forEach(function (k) { var v = getComputedStyle(R).getPropertyValue(k).trim(); if (v) BARRE.style.setProperty(k, v); });
      BARRE.querySelector('button').addEventListener('click', function () {
        var cible = !$('jpe-devis').hidden ? $('jpe-devis') : $('jpe-ajout');
        cible.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { actionsVues = e[0].isIntersecting; afficherBarre(); }, { threshold: 0.1 }).observe(q('.jpe-sel-zone') || $('jpe-ajout'));
        new IntersectionObserver(function (e) { configVue = e[0].isIntersecting; afficherBarre(); }).observe($('jpe-form'));
      } else configVue = true;
      return BARRE;
    }
    function afficherBarre() {
      if (!BARRE) return;
      var on = configVue && !actionsVues && BARRE.dataset.total !== '0';
      BARRE.classList.toggle('is-visible', on);
      document.documentElement.classList.toggle('jpe-barre-on', on);
    }
    function majBarre(K, devis) {
      var b = creerBarre(), n = K.qtot;
      b.dataset.total = String(K.tot > 0 ? 1 : 0);
      b.querySelector('.jpe-barre__t').textContent = T('t_barre') + (n ? ' · ' + n + ' pièce' + (n > 1 ? 's' : '') : '');
      b.querySelector('strong').textContent = eur(K.tot) + ' HT';
      var liv = b.querySelector('.jpe-barre__liv'), fil = b.querySelector('.jpe-barre__fil');
      if (cfg.franco && K.tot > 0) {
        var reste = cfg.franco - K.tot, ok = reste <= 0;
        liv.hidden = false; fil.hidden = false;
        liv.textContent = (ok ? '\u2713 ' + T('t_liv_ok') : T('t_liv_reste', { reste: eur(reste) }));
        liv.classList.toggle('is-ok', ok); fil.classList.toggle('is-ok', ok);
        fil.querySelector('i').style.width = Math.min(100, Math.round(K.tot / cfg.franco * 100)) + '%';
      } else { liv.hidden = true; fil.hidden = true; }
      var pret = devis || ((SEL.length && qte() === 0) || (lignePrete() && (SEL.length || qte() >= minimum())));
      var btn = b.querySelector('button'); btn.hidden = !pret; btn.textContent = devis ? T('t_devis_btn') : T('t_barre_btn');
      afficherBarre();
    }
    /* ---- Mobile : bouton flottant « Voir l'aperçu » quand l'aperçu est sorti de l'écran ---- */
    var VOIR = $('jpe-voir'), ZOOM = $('jpe-zoom');
    if (VOIR && ZOOM) {
      document.body.appendChild(VOIR); document.body.appendChild(ZOOM);
      var csZ = getComputedStyle(R); ['--jpe-acc', '--jpe-fond', '--jpe-tx', '--jpe-doux', '--jpe-ligne', '--jpe-titre', '--jpe-machine'].forEach(function (k) { var v = csZ.getPropertyValue(k).trim(); if (v) { VOIR.style.setProperty(k, v); ZOOM.style.setProperty(k, v); } });
      var form = $('jpe-form'), cadre = q('.jpe-apercu__cadre'), formVu = false, apercuVu = true;
      function majVoir() { VOIR.hidden = !(window.innerWidth < 900 && formVu && !apercuVu && ZOOM.hidden); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { formVu = en[0].isIntersecting; majVoir(); }).observe(form);
        new IntersectionObserver(function (en) { apercuVu = en[0].isIntersecting; majVoir(); }, { threshold: 0.15 }).observe(cadre);
      }
      window.addEventListener('resize', majVoir);
      var fermerZoom = function () { ZOOM.hidden = true; ZOOM.classList.remove('is-photo'); bloquerPage(false); majVoir(); };
      VOIR.addEventListener('click', function () {
        var z = $('jpe-zoom-img'); z.innerHTML = $('jpe-pot').innerHTML;
        ZOOM.hidden = false; bloquerPage(true); majVoir();
        var ca = z.querySelector('.jpe-ca'); if (ca) ajusterCarte(ca);
        ZOOM.querySelector('.jpe-fen__x').focus();
      });
      ZOOM.addEventListener('click', function (e) { if (e.target === ZOOM || e.target.closest('.jpe-fen__x')) fermerZoom(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ZOOM.hidden) fermerZoom(); });
      R.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.jpe-sachet__loupe'); if (!b) return;
        e.preventDefault();
        $('jpe-zoom-img').innerHTML = (zoomSachet(b.dataset.nom, b.dataset.src, 'jpe-zoom__grand') || '<img class="jpe-zoom__photo" src="' + esc(b.dataset.src) + '" alt="">') + '<p class="jpe-zoom__nom">' + esc(b.dataset.nom || '') + '</p>';
        ZOOM.classList.add('is-photo'); ZOOM.hidden = false; bloquerPage(true); majVoir();
        ZOOM.querySelector('.jpe-fen__x').focus();
      });
    }

    /* ---- Échantillon : 1 pièce du modèle choisi, message d'exemple, au prix du modèle, port du profil entreprise ---- */
    function echVariante() {
      if (estCarte()) { var c = carteChoisie() || (cfg.carte || [])[0]; return c ? { id: c.id, p: c.p, nom: T('m_carte_nom') + (c.t && c.t !== 'Default Title' ? ', ' + c.t : '') } : null; }
      var v = trouver(E.m, E.f, false, false); if (!v) return null;
      var lab = q('input[name="jpe-modele"]:checked'), nom = lab ? lab.closest('.jpe-modele').querySelector('strong').textContent : E.m;
      return { id: v.id, p: v.p, nom: nom + (finitionsDe(E.m).length > 1 ? ', ' + E.f : '') };
    }
    function majEch() {
      var box = $('jpe-ech'); if (!box || box.hidden) return;
      var v = echVariante();
      $('jpe-ech-txt').textContent = v ? T('t_ech_txt', { modele: v.nom, prix: eur(ht(v.p)) }) : '';
      $('jpe-ech-err').hidden = true;
    }
    if ($('jpe-ech-lien')) {
      $('jpe-ech-lien').addEventListener('click', function () { $('jpe-ech').hidden = false; this.hidden = true; majEch(); });
      $('jpe-ech-non').addEventListener('click', function () { $('jpe-ech').hidden = true; $('jpe-ech-lien').hidden = false; });
      R.addEventListener('change', majEch);
      $('jpe-ech-ok').addEventListener('click', function () {
        var v = echVariante(), btn = this, base = btn.textContent, err = $('jpe-ech-err');
        if (!v) return;
        btn.disabled = true;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          var deja = (c.items || []).some(function (it) { return it.variant_id === v.id && it.properties && it.properties['Échantillon']; });
          if (deja) { err.textContent = T('t_ech_deja'); err.hidden = false; btn.disabled = false; return; }
          var pr = { 'Échantillon': "Oui, message d'exemple" };
          if ($('jpe-ent').value.trim()) pr.Entreprise = $('jpe-ent').value.trim();
          if (emailOk()) pr['E-mail'] = $('jpe-email').value.trim();
          prevenir('Échantillon ajouté au panier : ' + v.nom);
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: pr }] }) })
            .then(function (r) { if (!r.ok) throw r; window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart'; });
        }).catch(function () { btn.disabled = false; btn.textContent = base; err.textContent = T('e_panier'); err.hidden = false; });
      });
    }

    /* Pré-footer du thème masqué sur cette page : toutes les sections placées entre le contenu et le pied de page,
       à n'importe quel niveau de la page, ou celles nommées dans le réglage */
    if (cfg.sansPrefooter) {
      var estPied = function (el) { return el.tagName === 'FOOTER' || /(^|section-)footer$/i.test(el.id || '') || (el.querySelector && el.querySelector('footer, .Footer, [data-section-type="footer"]')); };
      var cacher = function (el) {
        if (!el.classList || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        if (/popup|newsletter|modal|drawer|cart|header/i.test((el.id || '') + ' ' + (el.className || ''))) return;
        if (el.classList.contains('shopify-section') || el.tagName === 'SECTION' || el.tagName === 'ASIDE') el.style.display = 'none';
      };
      var n = R.closest('main') || R;
      outer: while (n && n !== document.body) {
        for (var el = n.nextElementSibling; el; el = el.nextElementSibling) { if (estPied(el)) break outer; cacher(el); }
        n = n.parentElement;
      }
      String(cfg.prefooterIds || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean).forEach(function (id) {
        document.querySelectorAll('#' + id.replace(/^#/, '') + ', #shopify-section-' + id.replace(/^#/, '')).forEach(function (x) { x.style.display = 'none'; });
      });
    }

    remplirDessins();
    renduFinitions();
    tout();
  }
    /* Bouton du haut : arrivée juste sous l'en-tête fixe du thème, sur-titre et titre visibles */
function hauteurEntete() {
  var h = 0;
  document.querySelectorAll('header, .Header, #shopify-section-header, [data-section-type="header"], .shopify-section--header').forEach(function (el) {
    var st = getComputedStyle(el); if (st.position !== 'fixed' && st.position !== 'sticky') return;
    var r = el.getBoundingClientRect(); if (r.top <= 5 && r.bottom > h && r.bottom < 300) h = r.bottom;
  });
  return h;
}
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#jpe-config"]'); if (!a) return;
  var sec = document.getElementById('jpe-config'); if (!sec) return;
  var cible = sec.querySelector('.jpe-sur') || sec.querySelector('h2') || sec;
  e.preventDefault();
  var y = cible.getBoundingClientRect().top + window.pageYOffset - Math.max(hauteurEntete(), 90) - 28;
  window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  setTimeout(function () { var y2 = cible.getBoundingClientRect().top + window.pageYOffset - Math.max(hauteurEntete(), 90) - 28; if (Math.abs(y2 - window.pageYOffset) > 8) window.scrollTo({ top: Math.max(0, y2), behavior: 'smooth' }); }, 700);
  if (history.replaceState) history.replaceState(null, '', '#jpe-config');
});

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-jpe-seo]'); if (!b) return;
    var z = document.getElementById(b.getAttribute('aria-controls')); if (!z) return;
    var ouvert = b.getAttribute('aria-expanded') === 'true';
    if (ouvert) { z.style.maxHeight = z.scrollHeight + 'px'; z.classList.remove('is-ouvert'); requestAnimationFrame(function () { z.style.maxHeight = '0px'; }); }
    else { z.style.maxHeight = z.scrollHeight + 'px'; setTimeout(function () { z.classList.add('is-ouvert'); z.style.maxHeight = ''; }, 360); }
    b.setAttribute('aria-expanded', ouvert ? 'false' : 'true'); b.textContent = ouvert ? b.dataset.plus : b.dataset.moins;
  });
  function lancer() { document.querySelectorAll('script[id^="jpe-data-"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer); else lancer();
  document.addEventListener('shopify:section:load', lancer);
})();
